// Fuente única del glosario AEO. La consumen:
//  - src/views/glosario/GlosarioIndex.js (render + buscador)
//  - el MCP público (public/glosario.json generado en build → worker-mcp: buscar_glosario)
// EDITAR SOLO AQUÍ. ESM puro (sin imports de Next). Los defs usan markdown ligero:
//   `code` → <Code> y **bold** → <strong> (los renderiza renderDef en el componente).

export const TERMS = [
  /* A */
  {
    letter: 'A',
    term: 'AI Mode',
    acro: 'GOOGLE · MOTOR · 2025→',
    def: 'Modo conversacional dentro de Google Search lanzado en 2025: el usuario hace preguntas largas y obtiene una respuesta sintética con citas, sin SERP tradicional debajo. Va más allá de AI Overviews porque arma sesiones multi-turno. Es el frente más nuevo del AEO — y donde la baseline de la mayoría de las marcas es 0%.',
    seeAlso: [
      { label: 'Artículo · AI Mode, 1.000 millones', href: '/blog/ai-mode-1000-millones-usuarios' },
    ],
  },
  {
    letter: 'A',
    term: 'AggregateRating',
    acro: 'SCHEMA.ORG · TÉCNICO',
    def: 'Tipo de schema.org que estructura la calificación agregada de una marca o producto (promedio de estrellas + número de reseñas) en datos legibles por máquina. Junto con Organization y SoftwareApplication, es uno de los bloques que los LLMs leen para resolver reputación: sin él, el modelo ve el texto de tus reseñas pero no la señal numérica consolidada que pondera al citar.',
    seeAlso: [
      { label: 'Schema.org', anchor: '#schema-org' },
      { label: 'JSON-LD', anchor: '#json-ld' },
    ],
  },
  {
    letter: 'A',
    term: 'Alexa for Shopping',
    acro: 'AMAZON · MOTOR',
    def: 'Asistente de compra de Amazon; hasta mayo de 2026 se llamaba Amazon Rufus, cuando Amazon lo unificó con Alexa+. Responde preguntas de producto, compara, sigue precios y automatiza compras dentro de Amazon, y con «Buy for Me» compra también en sitios de otras marcas. Para marcas que venden en Amazon, optimizar fichas para este asistente — atributos completos, reseñas, contenido A+ — es AEO aplicado al marketplace, no SEO de Amazon clásico.',
    seeAlso: [
      { label: 'Motor generativo', anchor: '#motor-generativo' },
      { label: 'Agentic Commerce', anchor: '#agentic-commerce' },
    ],
  },
  {
    letter: 'A',
    term: 'Anchor text',
    acro: 'TEXTO ANCLA · SEO',
    def: 'El texto visible de un hipervínculo. Para SEO importaba como señal semántica del destino; para AEO importa como input de disambiguación: si tu marca es enlazada con anchor "Bison" en 100 sitios y con "Bison Agents" en otros 100, el modelo tiene dos entidades candidatas. Anchors consistentes son disambiguación a escala.',
  },
  {
    letter: 'A',
    term: 'Atribución',
    acro: 'ATTRIBUTION · MARKETING',
    def: 'Cómo asignas crédito al canal o touchpoint que generó una conversión. El AEO rompe los modelos clásicos: una cita en ChatGPT puede ser invisible para tu analytics pero estar al inicio de la mitad de tus deals. Recomendamos atribución asistida + encuestas explícitas en formulario ("¿Dónde nos viste primero?").',
  },
  {
    letter: 'A',
    term: 'ACP',
    acro: 'AGENTIC COMMERCE PROTOCOL · UCP / COMMERCE',
    def: 'Protocolo abierto impulsado por OpenAI y Stripe para que un agente complete una compra dentro del chat; nació como base de Instant Checkout en ChatGPT (2025) y hoy define cómo los comercios entregan su catálogo a ChatGPT. Compite y convive con el UCP de Google: mismo problema, dos estándares. Una marca seria publica para ambos, igual que en su momento publicaba para Google y para Bing. Ojo con la sigla: el ACP de IBM (Agent Communication Protocol), para comunicar agentes entre sí, se fusionó con A2A en agosto de 2025, y el ACP de Zed (Agent Client Protocol) conecta agentes de programación con editores de código.',
    seeAlso: [
      { label: 'UCP', anchor: '#ucp' },
      { label: 'Instant Checkout', anchor: '#instant-checkout' },
      { label: 'Artículo · ACP y UCP', href: '/blog/comercio-agentico-acp-ucp' },
    ],
  },
  {
    letter: 'A',
    term: 'A2A',
    acro: 'AGENT2AGENT · UCP / COMMERCE',
    def: 'El **Agent2Agent** es el protocolo abierto para que un agente de IA le delegue una tarea a otro agente, aunque sea de otro proveedor, y siga su avance hasta el resultado. Google lo lanzó en abril de 2025 y desde junio de 2025 lo gobierna la Linux Foundation, que en agosto de 2025 sumó a él el ACP de IBM. Cada agente se presenta con una tarjeta en `/.well-known/agent-card.json` y trabaja por tareas con estado. No es un protocolo de comercio, aunque el UCP de Google lo admite como transporte: MCP conecta un agente con herramientas y datos; A2A, un agente con otro.',
    seeAlso: [
      { label: 'MCP', anchor: '#mcp' },
      { label: 'UCP', anchor: '#ucp' },
      { label: 'ACP', anchor: '#acp' },
    ],
  },
  {
    letter: 'A',
    term: 'AP2',
    acro: 'AGENT PAYMENTS PROTOCOL · UCP / COMMERCE',
    def: 'Estándar impulsado por Google y socios de pagos para autorizar y liquidar transacciones iniciadas por agentes, con mandatos verificables del usuario. Es la pieza que falta entre "el agente eligió tu producto" y "el agente lo pagó". Sin rieles de pago agénticos, el zero-click commerce se queda en cotización.',
    seeAlso: [
      { label: 'ACP', anchor: '#acp' },
      { label: 'UCP', anchor: '#ucp' },
      { label: 'A2A', anchor: '#a2a' },
    ],
  },
  {
    letter: 'A',
    term: 'Agentic Commerce',
    acro: 'COMMERCE · UCP / COMMERCE',
    def: 'Compra ejecutada por un agente LLM en nombre del usuario — desde cotizar un seguro hasta cerrar un carrito de e-commerce dentro del propio chat. Requiere que tu marca esté en el índice de retrieval y que tus precios, stock y políticas sean machine-readable. La nueva frontera del AEO a 18 meses.',
    seeAlso: [
      { label: 'Artículo · ACP y UCP', href: '/blog/comercio-agentico-acp-ucp' },
    ],
  },
  {
    letter: 'A',
    term: 'Answer Engine Insights',
    acro: 'AEI · MÉTRICA / MARCO',
    def: 'La capa de inteligencia que se obtiene al medir AEO sistemáticamente: qué prompts disparan tu marca, qué competidor te roba cobertura en qué motor, qué fuentes te citan, qué sesgos arrastra cada modelo, cómo cambia tu sentiment week-over-week. AEO es la acción; AEI es el conocimiento que esa acción produce. En Bison, los AEI alimentan el roadmap del cliente y el playbook global.',
    seeAlso: [{ label: 'Plataforma', href: '/' }],
  },
  {
    letter: 'A',
    term: 'Answer Engine Optimization',
    acro: 'AEO · MARCO · 2023→',
    def: 'Conjunto de prácticas para que una marca sea citada (no solo enlazada) por motores generativos como ChatGPT, Gemini, Perplexity, Claude y Google AI Overviews. Sucede al SEO sin reemplazarlo: el SEO optimiza para 10 enlaces; el AEO para una respuesta.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'A',
    term: 'Agente',
    acro: 'LLM AGENT · TÉCNICO',
    def: 'Sistema que combina un LLM con herramientas (búsqueda web, código, APIs) y un loop de razonamiento para ejecutar tareas multi-paso. Los agentes consumen información de marcas con mayor profundidad que un chat directo: si tu marca solo aparece en respuestas superficiales, los agentes te dejan fuera.',
  },
  {
    letter: 'A',
    term: 'AI Overviews',
    acro: 'AIO · ANTES SGE · MOTOR',
    def: 'El bloque generativo que Google muestra sobre los resultados azules tradicionales, citando 3–8 fuentes por consulta. Es, para la mayoría de las marcas, la primera puerta donde pasan de competir por un puesto en el ranking de enlaces a competir por ser citadas dentro de una respuesta. Optimizar para AIO es AEO aplicado al buscador más grande del mundo.',
    seeAlso: [
      { label: 'Artículo · de AI Overviews a AI Mode', href: '/blog/google-empuja-a-ai-mode' },
    ],
  },
  {
    letter: 'A',
    term: 'AX',
    acro: 'AGENT EXPERIENCE · MARCO',
    def: 'El equivalente de UX para agentes: qué tan fácil es para un agente LLM entender tu oferta, navegar tu catálogo y transaccionar contigo. Une llms.txt (capa declarativa), MCP (capa de herramientas) y UCP/ACP (capa transaccional). La pregunta de diseño cambia: ya no es "¿lo entiende mi usuario?" sino "¿lo entiende el agente de mi usuario?".',
    seeAlso: [
      { label: 'MCP', anchor: '#mcp' },
      { label: 'UCP', anchor: '#ucp' },
      { label: 'Function calling', anchor: '#function-calling' },
    ],
  },
  {
    letter: 'A',
    term: 'Arquetipo de marca',
    acro: 'ARQUETIPOS · PROCESO',
    def: 'Una de las seis clasificaciones que usamos para priorizar el playbook: D2C retail, SaaS B2B, Servicios profesionales, Marca local, E-commerce, Plataforma o agencia. El arquetipo determina el orden en que se ejecutan las acciones del primer ciclo.',
    seeAlso: [{ label: '6 arquetipos', href: '/metodologia' }],
  },
  {
    letter: 'A',
    term: 'Alucinación',
    acro: 'HALLUCINATION · TÉCNICO',
    def: 'Cuando un LLM inventa un hecho con apariencia de verdad. Para tu marca, una alucinación negativa es un dato falso citado como tuyo: precios inventados, features que no existen, fusiones imaginarias. Se cuantifica con la tasa de alucinación —el porcentaje de respuestas con datos falsos sobre tu marca, reportada por motor porque cada uno alucina distinto— y es la métrica defensiva del AEO. Se mitiga con cobertura editorial verificable y consistente: si la verdad está bien indexada y repetida, el modelo la prefiere.',
  },

  /* B */
  {
    letter: 'B',
    term: 'Búsqueda semántica',
    acro: 'SEMANTIC SEARCH · TÉCNICO',
    def: 'Búsqueda que interpreta la intención y el significado de una consulta, no solo las palabras exactas. Es la base técnica común a SEO moderno y AEO: el motor convierte tu contenido y la consulta en embeddings y compara significado, no keywords. Por eso escribir para la entidad y el contexto — y no para repetir la palabra clave — es lo que hace que el motor te considere relevante.',
    seeAlso: [
      { label: 'Embedding', anchor: '#embedding' },
      { label: 'Retrieval', anchor: '#retrieval' },
    ],
  },
  {
    letter: 'B',
    term: 'BERT',
    acro: 'LLM HISTÓRICO · TÉCNICO',
    def: 'Modelo bidireccional de Google (2018) que fue uno de los primeros LLMs en producción a escala. Antes de BERT, los rankings se decidían con TF-IDF + PageRank; después, con embeddings semánticos. Marca el inicio práctico de la era pre-AEO. Hoy Google usa modelos descendientes (MUM, Gemini) pero BERT sigue corriendo bajo el capó de muchas SERPs.',
  },
  {
    letter: 'B',
    term: 'Brand SERP',
    acro: 'BRAND SERP · SEO / AEO',
    def: 'La SERP que aparece cuando alguien busca exactamente el nombre de tu marca. Es la foto pública oficial: knowledge panel, redes, casos, prensa, foros. Si tu Brand SERP está rota (sin panel, con resultados de competidor, con foros negativos arriba), el LLM aprende lo mismo. Limpiarla es uno de los primeros pasos de cualquier diagnóstico.',
  },
  {
    letter: 'B',
    term: 'Backlink',
    acro: 'ENLACE EXTERNO · SEO',
    def: 'Enlace que un sitio de terceros hace hacia el tuyo. Pilar histórico del SEO. En AEO sigue importando, pero como señal indirecta: un backlink desde Tier-1 muestra autoridad al motor de retrieval, no a un algoritmo de PageRank. Cantidad ya no manda; contexto + autoridad de la fuente sí.',
  },
  {
    letter: 'B',
    term: 'Baseline',
    acro: 'BASELINE · MÉTRICA',
    def: 'El Score AEO inicial (0–100) con el que una marca entra al ciclo, medido con sus cuatro componentes (menciones, citabilidad, posición y sentimiento); no es el puntaje del diagnóstico 4D. Toda mejora se mide contra él —no contra ventanas móviles— para que el progreso sea atribuible. Es la foto del «antes» que vuelve demostrable el impacto del trabajo, como el salto 3→82 de los casos.',
  },
  {
    letter: 'B',
    term: 'Brand Awareness',
    acro: 'RECONOCIMIENTO · MARKETING',
    def: '% de tu audiencia objetivo que puede mencionar tu marca sin asistencia (top-of-mind) o reconocerla con asistencia (aided). En AEO la métrica equivalente es la cobertura: ya no preguntas a humanos, preguntas a los motores que esos humanos consultan. Cuando un LLM te menciona en su respuesta principal, tu awareness se materializa antes de cualquier impresión publicitaria.',
  },
  {
    letter: 'B',
    term: 'Brand Brain',
    acro: 'CONCEPTO · MARCO',
    def: 'La fuente de verdad centralizada e interna de tu marca dentro de Bison (entidades, productos, FAQs, comparativas y fuentes verificables) que se mantiene y se proyecta a los motores. Sirve para validar lo que la IA dice de ti (anti-alucinación) y alimentar la generación de contenido con datos reales. Lo que el modelo retiene sobre ti es tu "huella en los modelos" — no el Brand Brain, que es el activo interno que la alimenta.',
  },

  /* C */
  {
    letter: 'C',
    term: 'Categorías de prompts',
    acro: 'TIPOS · PROCESO',
    def: 'La clasificación en cuatro tipos que usamos para construir el catálogo de medición: (1) Descubrimiento — consultas de categoría sin mencionar marca, miden visibilidad orgánica; (2) Identidad — preguntas directas sobre la marca, verifican reconocimiento de entidad; (3) Competencia — comparativas entre marcas, miden share-of-voice relativo; (4) Reputación — consultas sobre experiencia y confianza, detectan riesgos de sentiment. Cada tipo alimenta una dimensión distinta del Score AEO.',
    seeAlso: [
      { label: 'Prompt', anchor: '#prompt' },
      { label: 'Score AEO', anchor: '#score-aeo' },
    ],
  },
  {
    letter: 'C',
    term: 'Chain-of-thought',
    acro: 'CoT · TÉCNICO',
    def: 'Técnica donde el LLM "piensa en voz alta" antes de responder, generando pasos intermedios. Los modelos de razonamiento (los de OpenAI, Claude con extended thinking, Gemini con thinking) son más exigentes con las fuentes: revisitan citas, descartan inconsistencias. Una marca con datos confusos pierde más en motores CoT que en motores de respuesta directa.',
  },
  {
    letter: 'C',
    term: 'ChatGPT Search',
    acro: 'OPENAI SEARCH · MOTOR',
    def: 'Capa de búsqueda con índice web propio dentro de ChatGPT, rastreado por OAI-SearchBot. Cambia las reglas: el modelo ya no responde solo desde memoria, recupera en vivo. Para AEO significa que tu contenido nuevo puede ser citado en días, no en el próximo entrenamiento — si tu sitio es legible para su crawler.',
    seeAlso: [
      { label: 'OAI-SearchBot', anchor: '#oai-searchbot' },
      { label: 'Corte de entrenamiento', anchor: '#corte-de-entrenamiento' },
    ],
  },
  {
    letter: 'C',
    term: 'ChatGPT',
    acro: 'OPENAI · MOTOR',
    def: 'Producto de OpenAI que envuelve la familia de modelos GPT y de razonamiento de OpenAI vigentes (a junio 2026) en una interfaz conversacional. El motor generativo con mayor base de usuarios activos del mundo. En Bison lo cubrimos por defecto desde el primer ciclo porque concentra el mayor volumen de consultas de compra en categorías B2B. Las citas varían según qué versión del modelo está activa — los cortes de entrenamiento de cada release pueden silenciar una marca durante semanas.',
  },
  {
    letter: 'C',
    term: 'Consenso entre fuentes',
    acro: 'CONSENSUS · MARCO',
    def: 'El mecanismo por el cual un LLM decide qué afirmar: si ocho fuentes independientes dicen lo mismo de tu marca, eso es "verdad" para el modelo. Explica por qué una sola página perfecta no basta y por qué el AEO es un juego de cobertura multi-fuente: prensa, reseñas, foros, Wikipedia y tu sitio diciendo lo mismo, con las mismas palabras clave de entidad.',
    seeAlso: [
      { label: 'Co-citación', anchor: '#co-citacion' },
      { label: 'Alucinación', anchor: '#alucinacion' },
    ],
  },
  {
    letter: 'C',
    term: 'Copilot',
    acro: 'MICROSOFT · MOTOR',
    def: 'Asistente de Microsoft integrado en Windows, Edge, Bing y Microsoft 365. Hereda el índice de Bing: una marca invisible en Bing es invisible en Copilot. Es el motor más subestimado en B2B corporativo — vive dentro del Office del comprador, donde se redactan los shortlists y los RFPs.',
    seeAlso: [{ label: 'Motor generativo', anchor: '#motor-generativo' }],
  },
  {
    letter: 'C',
    term: 'Corpus de entrenamiento',
    acro: 'TRAINING CORPUS · TÉCNICO',
    def: 'El conjunto de datos con que se entrenó el modelo. Distinto del índice de retrieval: el corpus define lo que el modelo "sabe de memoria"; el índice, lo que puede consultar en vivo. El AEO de largo plazo apunta al corpus — estar en las fuentes que se rastrean para entrenar (Wikipedia, prensa, foros) — y el de corto plazo, al índice.',
    seeAlso: [
      { label: 'Índice de retrieval', anchor: '#indice-de-retrieval' },
      { label: 'Corte de entrenamiento', anchor: '#corte-de-entrenamiento' },
    ],
  },
  {
    letter: 'C',
    term: 'Corte de entrenamiento',
    acro: 'KNOWLEDGE CUTOFF · TÉCNICO',
    def: 'Fecha hasta la cual llega el corpus con que se entrenó un modelo. Todo lo publicado después solo existe para el motor vía retrieval. Explica por qué una marca nueva puede dominar en Perplexity (retrieval-first) y ser invisible para el mismo modelo sin búsqueda activa — y por qué un lanzamiento sin estrategia de retrieval tarda meses en "existir".',
    seeAlso: [
      { label: 'Corpus de entrenamiento', anchor: '#corpus-de-entrenamiento' },
      { label: 'Retrieval', anchor: '#retrieval' },
    ],
  },
  {
    letter: 'C',
    term: 'Crawl budget',
    acro: 'PRESUPUESTO DE RASTREO · SEO / TÉCNICO',
    def: 'Cuántas páginas rastrea un bot por visita a tu sitio. En SEO clásico era problema de sitios enormes; con los crawlers de LLMs — más perezosos y menos frecuentes que Googlebot — es problema de todos. Sitemap limpio, arquitectura plana y contenido prioritario a pocos clics de la home dejan de ser higiene y pasan a ser estrategia.',
    seeAlso: [
      { label: 'Crawler', anchor: '#crawler' },
      { label: 'XML Sitemap', anchor: '#xml-sitemap' },
    ],
  },
  {
    letter: 'C',
    term: 'Context window',
    acro: 'VENTANA DE CONTEXTO · TÉCNICO',
    def: 'Cantidad máxima de tokens que un LLM puede procesar en una misma sesión (prompt + respuesta + documentos retrieved). Hoy 200k–2M tokens en modelos frontera. Para AEO importa porque define cuántas fuentes el motor puede leer antes de citar: contenido largo y bien estructurado puede entrar entero; contenido fragmentado se trunca.',
  },
  {
    letter: 'C',
    term: 'Conversion Rate',
    acro: 'CR · MARKETING',
    def: '% de visitantes que completan la acción objetivo (lead, compra, demo). En AEO la conversión cambia de forma: muchos leads llegan pre-calificados por el LLM y convierten 2–3× mejor que un lead SEO equivalente. El embudo se acorta porque la educación sucede dentro del chat.',
  },
  {
    letter: 'C',
    term: 'Core Web Vitals',
    acro: 'CWV · SEO / TÉCNICO',
    def: 'Las tres métricas de experiencia que Google considera factor de ranking: `LCP` (largest contentful paint), `INP` (interaction to next paint), `CLS` (cumulative layout shift). En AEO no son factor directo, pero sí indirecto: si el crawler no carga bien tu página, tu contenido no entra al índice de retrieval.',
  },
  {
    letter: 'C',
    term: 'Customer Journey',
    acro: 'RECORRIDO DEL CLIENTE · MARKETING',
    def: 'Las etapas que recorre un usuario desde descubrir tu marca hasta convertirse en cliente (y referente). El AEO comprime las primeras etapas: descubrimiento + consideración + comparación pueden ocurrir todas en una sola sesión de chat. La conversión llega a tu sitio ya decidida — o no llega nunca.',
  },
  {
    letter: 'C',
    term: 'CAC',
    acro: 'CUSTOMER ACQUISITION COST · MARKETING',
    def: 'Costo promedio para adquirir un cliente, sumando ventas + marketing dividido por número de clientes nuevos. El AEO impacta el CAC de dos formas: reduce el costo del lead inbound (citas son gratis post-setup) y mejora la calidad porque viene pre-educado por el LLM.',
  },
  {
    letter: 'C',
    term: 'Canonical',
    acro: 'rel="canonical" · SEO / TÉCNICO',
    def: 'Tag HTML que indica al crawler cuál es la URL preferida cuando hay contenido duplicado o accesible desde varios paths. Crítico para LLMs: si el modelo encuentra la misma información en tres URLs distintas y ninguna es canónica, dispersa señal y no resuelve entidad.',
  },
  {
    letter: 'C',
    term: 'Cita',
    acro: 'CITATION · MÉTRICA',
    def: 'Mención de tu marca en una respuesta de un motor generativo, idealmente con link a una fuente verificable (tu sitio, prensa Tier-1, Wikipedia, G2). Las citas son la moneda dura del AEO: medibles, contables, durables.',
    seeAlso: [
      { label: 'Artículo · escribe para que te citen', href: '/blog/escribir-para-que-la-ia-te-cite' },
    ],
  },
  {
    letter: 'C',
    term: 'Co-citación',
    acro: 'CO-OCCURRENCE · TÉCNICO',
    def: 'Patrón en que tu marca aparece junto a otras entidades en las mismas fuentes ("las 5 mejores plataformas X"). Los LLMs aprenden categorías por co-ocurrencia: si nunca apareces en listas junto a tus competidores, el modelo no sabe que compites con ellos. Estar en la comparativa — aunque no la ganes — es requisito para existir en la categoría.',
    seeAlso: [
      { label: 'Entidad', anchor: '#entidad' },
      { label: 'Consenso entre fuentes', anchor: '#consenso-entre-fuentes' },
    ],
  },
  {
    letter: 'C',
    term: 'Cobertura',
    acro: 'COVERAGE · MÉTRICA',
    def: 'Porcentaje de los prompts de tu categoría en los que tu marca aparece citada al menos una vez en un motor dado. Si tienes 100 prompts mapeados y el motor te cita en 40, tu cobertura es 40% — la métrica de primer contacto del AEO. Se mide por motor y por idioma: 60% en ChatGPT y 12% en Gemini son dos problemas distintos. Bison la reporta agregada y desagregada en cada ciclo semanal.',
  },
  {
    letter: 'C',
    term: 'ChatGPT Shopping',
    acro: 'OPENAI · MOTOR / COMMERCE',
    def: 'Capa de compra dentro de ChatGPT: recomienda productos con precio y foto en la respuesta conversacional, a partir del feed de catálogo que entregan los comercios (ACP). En marzo de 2026 OpenAI dejó de priorizar Instant Checkout y la compra pasó a cerrarse en el checkout de la tienda o en apps como la de Walmart. Para una marca, el trabajo hoy es estar en ese catálogo con precios, stock y atributos exactos: ser recomendada es la puerta a la venta.',
    seeAlso: [
      { label: 'Instant Checkout', anchor: '#instant-checkout' },
      { label: 'ACP', anchor: '#acp' },
      { label: 'Agentic Commerce', anchor: '#agentic-commerce' },
    ],
  },
  {
    letter: 'C',
    term: 'Chunking',
    acro: 'FRAGMENTACIÓN · TÉCNICO',
    def: 'Cómo un pipeline RAG parte tu página en fragmentos antes de indexarla. El motor no cita páginas: cita chunks. Un H2 claro más un párrafo autocontenido de 60–100 palabras es un chunk citable; una pared de texto de 800 palabras es un chunk truncado que nadie cita. Escribe en chunks, no en páginas.',
    seeAlso: [
      { label: 'RAG', anchor: '#rag' },
      { label: 'Embedding', anchor: '#embedding' },
      { label: 'Tokens', anchor: '#tokens' },
    ],
  },
  {
    letter: 'C',
    term: 'Citabilidad',
    acro: 'CITABILITY · MARCO',
    def: 'La propiedad de un contenido de ser fácilmente extraíble y atribuible por un motor generativo: definición autocontenida, dato con fuente, autor identificable, URL estable. Es la métrica de calidad editorial del AEO — el equivalente a "legibilidad" en la era SEO. Un contenido puede ser excelente para humanos y tener citabilidad cero.',
    seeAlso: [
      { label: 'Chunking', anchor: '#chunking' },
      { label: 'Information gain', anchor: '#information-gain' },
      { label: 'Artículo · escribe para que te citen', href: '/blog/escribir-para-que-la-ia-te-cite' },
    ],
  },
  {
    letter: 'C',
    term: 'Cuota de citación',
    acro: 'CITATION SHARE · MÉTRICA',
    def: 'Porcentaje de las citas (fuentes enlazadas o nombradas) que un motor generativo usa en las respuestas de tu categoría y que apuntan a tu dominio o a páginas donde figuras. Se diferencia del **Share-of-Voice**, que cuenta menciones de marca, y de la **Citabilidad**, que es una propiedad del contenido: la cuota de citación mide cuántas veces la IA te usó como fuente frente a las demás fuentes que leyó. Como unos veinte dominios concentran cerca del 68% de las citas, la cuota se gana estando en ese conjunto corto, motor por motor.',
    seeAlso: [
      { label: 'Share-of-Voice', anchor: '#share-of-voice' },
      { label: 'Citabilidad', anchor: '#citabilidad' },
      { label: 'Artículo · las fuentes que la IA cita', href: '/blog/fuentes-que-la-ia-cita' },
    ],
  },
  {
    letter: 'C',
    term: 'Ciclo DAOP',
    acro: 'D · A · O · P · PROCESO',
    def: 'Las cuatro fases del trabajo trimestral: Diagnóstico, Auditoría, Optimización y Posicionamiento. Se repite cada 90 días y cada fase tiene un umbral explícito que dispara la siguiente al alcanzarse. Es el motor operativo que convierte la visibilidad en IA de un proyecto puntual en un proceso de mejora continua, medible ciclo a ciclo.',
  },
  {
    letter: 'C',
    term: 'Crawler',
    acro: 'BOT / ARAÑA · SEO / TÉCNICO',
    def: 'Programa que recorre la web para indexar contenido. Hoy hay dos camadas que importan: los clásicos (Googlebot, Bingbot) y los nuevos crawlers de LLMs (`GPTBot` de OpenAI, `ClaudeBot` de Anthropic, `PerplexityBot`, `Google-Extended`). Bloquearlos en `robots.txt` tiene consecuencias asimétricas: bloquear GPTBot te deja fuera de ChatGPT, no de Bing.',
    seeAlso: [
      { label: 'Artículo · pay-per-crawl', href: '/blog/cloudflare-pay-per-crawl-ia' },
    ],
  },
  {
    letter: 'C',
    term: 'CTR',
    acro: 'CLICK-THROUGH RATE · SEO / MARKETING',
    def: '% de impresiones que terminan en clic. Métrica reina del SEO clásico. En AEO pierde sentido aislada: el zero-click crece, y mucha conversión sucede dentro de la respuesta del LLM sin que haya clic. Lo reemplazamos por cobertura + share-of-voice + citas verificables.',
  },
  {
    letter: 'C',
    term: 'Claude',
    acro: 'ANTHROPIC · MOTOR',
    def: 'La familia de modelos de Anthropic, con cobertura completa en Bison vía su Messages API. Sus citas son first-class en la respuesta (campo `citations`) y tiende a ser más conservador que otros modelos al recomendar marcas: premia fuentes verificables y consistencia de entidad. Aparecer en Claude exige señales de confianza limpias, no volumen de contenido.',
  },
  {
    letter: 'C',
    term: 'Citation Graph',
    acro: 'GRAFO DE CITAS · TÉCNICO',
    def: 'Mapa que registra qué dominios cita cada motor generativo en cada respuesta, para un conjunto dado de prompts. Distinto del citation share (qué % de citas son tuyas): el citation graph muestra la red completa de fuentes — qué dominios alimentan al motor, cuáles co-aparecen con tu marca y cuáles te desplazan. Permite identificar los sitios de terceros donde construir presencia para ingresar al grafo de autoridad de tu categoría.',
    seeAlso: [
      { label: 'Co-citación', anchor: '#co-citacion' },
      { label: 'Share de citas', anchor: '#share-de-citas' },
      { label: 'Retrieval', anchor: '#retrieval' },
    ],
  },
  {
    letter: 'C',
    term: 'CMA',
    acro: 'COMPETITION AND MARKETS AUTHORITY · MARCO',
    def: 'Regulador de competencia del Reino Unido y, desde 2025, el primer árbitro vinculante de la búsqueda con IA. En junio de 2026 emitió la primera Conduct Requirement del mundo dirigida a un motor generativo, obligando a Google a ofrecer opt-out de AI Overviews sin penalización de ranking. Sus decisiones funcionan como termómetro global: lo que la CMA exige hoy suele volverse estándar regulatorio en otros mercados en 12–18 meses.',
    seeAlso: [
      { label: 'AI Overviews', anchor: '#ai-overviews' },
      { label: 'Opt-out AIO', anchor: '#opt-out-aio' },
    ],
  },

  /* D */
  {
    letter: 'D',
    term: 'Datos estructurados',
    acro: 'STRUCTURED DATA · TÉCNICO',
    def: 'Información organizada en un formato estándar que las máquinas pueden parsear sin ambigüedad — el caso más común es schema.org en JSON-LD. Distinto del schema como vocabulario: los datos estructurados son la práctica de marcar tu contenido (precios, FAQs, autor, valoraciones) para que el motor no tenga que inferirlos del texto. Sin ellos, el LLM adivina; con ellos, lee.',
    seeAlso: [
      { label: 'Schema.org', anchor: '#schema-org' },
      { label: 'JSON-LD', anchor: '#json-ld' },
      { label: 'AggregateRating', anchor: '#aggregaterating' },
      { label: 'Artículo · schema.org bien hecho', href: '/blog/schema-org-aeo' },
    ],
  },
  {
    letter: 'D',
    term: 'Deep Research',
    acro: 'INVESTIGACIÓN PROFUNDA · MOTOR / TÉCNICO',
    def: 'Modo de investigación multi-paso (OpenAI, Gemini, Perplexity) en que el agente lee decenas de fuentes, las contrasta y produce un informe con citas. Las marcas con contenido profundo, estructurado y verificable ganan desproporcionadamente aquí: el agente premia metodología y datos primarios, y castiga el contenido fino. Cada vez más decisiones B2B de ticket alto pasan por una sesión de Deep Research.',
    seeAlso: [
      { label: 'Agente', anchor: '#agente' },
      { label: 'Information gain', anchor: '#information-gain' },
    ],
  },
  {
    letter: 'D',
    term: 'DeepSeek',
    acro: 'DEEPSEEK AI · MOTOR',
    def: 'Familia de modelos de pesos abiertos de origen chino con adopción global creciente por costo y rendimiento. Para AEO importa por dos vías: alimenta motores y wrappers de terceros que tus clientes pueden estar usando, y su corpus se congela en cada release — lo que tu marca era al momento del entrenamiento es lo que el modelo repite.',
    seeAlso: [
      { label: 'Open weights', anchor: '#open-weights' },
      { label: 'Corte de entrenamiento', anchor: '#corte-de-entrenamiento' },
    ],
  },
  {
    letter: 'D',
    term: 'Domain Authority',
    acro: 'DA · SEO',
    def: 'Score 0–100 (creado por Moz) que estima la fuerza de un dominio para rankear en Google. Útil como proxy histórico, pero los LLMs no lo usan directamente: ellos evalúan autoridad por densidad de citas verificables. Un dominio joven con prensa Tier-1 puede vencer a un dominio viejo con DA alto pero sin presencia editorial.',
  },
  {
    letter: 'D',
    term: 'Diagnóstico 4D',
    acro: 'D1–D4 · PROCESO',
    def: 'Evaluación inicial que descompone tu visibilidad en cuatro dimensiones —Identidad firmográfica, Reputación verificable, Cobertura editorial y Cobertura social—, cada una de 0–25 puntos. Su suma (0–100) muestra en qué dimensión estás invisible para los modelos y prioriza dónde intervenir primero. Es un instrumento de **diagnóstico**, no el Score AEO de visibilidad.',
    seeAlso: [{ label: 'Diagnóstico', href: '/metodologia' }],
  },
  {
    letter: 'D',
    term: 'Delta competitivo',
    acro: 'Δ COMP · MÉTRICA',
    def: 'Diferencia de cobertura entre tu marca y tu competidor #1 en una ventana de tiempo dada. Positivo significa que ganas terreno en las respuestas generativas; negativo, que tu rival se cita más y conviene activar el bloque de acciones competitivas. Es la métrica que convierte el share-of-voice abstracto en una lectura accionable frente a un competidor concreto.',
  },
  {
    letter: 'D',
    term: 'Disambiguación',
    acro: 'DISAMBIGUATION · TÉCNICO',
    def: 'El trabajo de lograr que el modelo resuelva tu nombre a una sola entidad. Checklist mínimo: nombre consistente en todas tus propiedades, sameAs estrictos, ítem de Wikidata con referencias, Knowledge Panel reclamado y anchors uniformes. Si "Bison" puede ser tu plataforma o una cervecería, el modelo elige no citarte — la ambigüedad se paga con silencio.',
    seeAlso: [
      { label: 'Entidad', anchor: '#entidad' },
      { label: 'sameAs', anchor: '#sameas' },
      { label: 'Wikidata', anchor: '#wikidata' },
    ],
  },
  {
    letter: 'D',
    term: 'DPA',
    acro: 'DATA PROCESSING AGREEMENT · TÉCNICO / LEGAL',
    def: 'Contrato que formaliza la relación entre Bison (encargado del tratamiento) y el cliente (responsable de los datos). Define qué datos personales se procesan, con qué base legal, cuánto tiempo y bajo qué salvaguardas técnicas y organizativas. Requerido por el RGPD europeo, la Ley 21.719 chilena y la LGPD brasileña para cualquier relación de encargo de tratamiento.',
    seeAlso: [{ label: 'Privacidad', href: '/privacidad' }],
  },

  /* E */
  {
    letter: 'E',
    term: 'E-A-T',
    acro: 'LEGADO 2014–2022 · SEO',
    def: 'Versión original del marco de Google antes de sumar la primera E (Experience). Se sigue usando en literatura SEO previa a 2022 y en algunos auditores. La extensión a E-E-A-T no fue cosmética: pasó a valorar evidencia de uso real (testimonios, casos, fotos), no solo credenciales declaradas.',
  },
  {
    letter: 'E',
    term: 'E-E-A-T',
    acro: 'EXPERIENCE · EXPERTISE · AUTHORITATIVENESS · TRUSTWORTHINESS · MARCO',
    def: 'Marco de calidad acuñado por Google para sus Search Quality Raters: Experience (vivencia directa), Expertise (conocimiento técnico), Authoritativeness (autoridad reconocida) y Trustworthiness (confianza verificable). Llegó al SEO en 2014 como E-A-T y sumó la primera E en 2022. Importa al AEO porque los LLMs heredan estas señales de los corpus de entrenamiento y del índice de retrieval — autor firmado, biografía verificable, casos con métricas y citas externas son E-E-A-T legible por máquina.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'E',
    term: 'Embedding',
    acro: 'VECTOR · TÉCNICO',
    def: 'Representación numérica de un texto que captura su significado. Los motores generativos usan embeddings para decidir qué fuentes son relevantes para una consulta. Tu contenido tiene que ser embeddable: estructurado, claro, autoritativo.',
  },
  {
    letter: 'E',
    term: 'Entidad',
    acro: 'ENTITY · TÉCNICO',
    def: 'Objeto único reconocido por un LLM: una marca, una persona, un producto. Si tu nombre se confunde con otro (e.g. "Bison" como cervecería vs. plataforma), el modelo no puede citarte. La disambiguación es el primer trabajo del AEO.',
  },

  /* F */
  {
    letter: 'F',
    term: 'Fan-out queries',
    acro: 'QUERY FAN-OUT · TÉCNICO',
    def: 'Patrón en que el motor convierte una consulta del usuario en varias sub-consultas internas que se ejecutan en paralelo contra el índice. Una pregunta como "comparar planes AEO en español" puede abrir varias sub-búsquedas: ranking de plataformas, precios en LatAm, casos de éxito, alternativas, etc. (Google no publica cuántas genera cada pregunta). Si tu marca solo aparece en una de esas sub-búsquedas, te cita una vez; si aparece en cuatro, te cita con autoridad. Optimizar para fan-out es la nueva forma de pensar topic clusters.',
  },
  {
    letter: 'F',
    term: 'Featured Snippet',
    acro: 'POSITION ZERO · SEO',
    def: 'Bloque con respuesta directa que Google muestra arriba de los 10 enlaces clásicos. Predecesor estructural del AI Overview. Lo que ganaba featured snippets en 2022 (estructura clara, párrafo de 40–60 palabras, lista numerada) sigue siendo el contenido que más fácilmente entra al overview generativo.',
  },
  {
    letter: 'F',
    term: 'Fine-tuning',
    acro: 'FINE-TUNING · TÉCNICO',
    def: 'Re-entrenamiento parcial de un LLM sobre tu dataset específico. No es AEO en sí — es un atajo para sistemas internos. Para marcas de LatAm el fine-tuning casi nunca compensa: el AEO opera sobre los modelos públicos, donde tus clientes ya están preguntando.',
  },
  {
    letter: 'F',
    term: 'Frecuencia de aparición',
    acro: 'RUN CONSISTENCY · MÉTRICA',
    def: 'El mismo prompt no devuelve siempre la misma respuesta: los motores muestrean. Esta métrica mide en qué porcentaje de runs apareces para un prompt dado. Cobertura del 100% con frecuencia del 30% significa que existes, pero el motor duda. Por eso Bison ejecuta 3–5 runs por motor por semana — una sola lectura es una anécdota, no un dato.',
    seeAlso: [
      { label: 'NER', anchor: '#ner' },
      { label: 'Cobertura', anchor: '#cobertura' },
    ],
  },
  {
    letter: 'F',
    term: 'Function calling',
    acro: 'TOOL USE · TÉCNICO',
    def: 'Capacidad de un LLM para invocar herramientas externas (APIs, búsqueda, calculadoras, MCP servers). Habilita los agentes y, por extensión, el UCP. Una marca que expone funciones (buscar producto, cotizar, agendar) bien documentadas es seleccionada por agentes mucho antes que una marca que solo tiene contenido legible.',
  },
  {
    letter: 'F',
    term: 'Familia',
    acro: 'FAMILIAS · PROCESO',
    def: 'Una de las ocho agrupaciones de acciones del playbook: Identidad, Técnica, Reputación, Editorial, Contenido, Social, Competitiva, Medición. Las familias se ordenan por dependencia — no se ejecutan acciones de Contenido sin tener Identidad consolidada.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'F',
    term: 'Funnel',
    acro: 'EMBUDO · MARKETING',
    def: 'Modelo en etapas que va desde awareness (TOFU) hasta cierre (BOFU). El AEO opera en las tres simultáneamente: TOFU cuando la cita es genérica ("plataformas AEO en español"), MOFU cuando es comparativa ("X vs Y"), BOFU cuando el LLM directamente recomienda tu marca para una intención específica.',
  },

  /* G */
  {
    letter: 'G',
    term: 'G2 / Capterra',
    acro: 'PLATAFORMAS DE RESEÑAS B2B · FUENTE',
    def: 'Plataformas de reseñas de software que Perplexity y ChatGPT citan sistemáticamente en consultas de compra B2B. Para un SaaS, quince reseñas verificadas en G2 valen más que quince posts del blog propio: son validación de terceros, la señal que los modelos ponderan más alto. Perfil reclamado, categoría correcta y flujo constante de reseñas es trabajo de AEO, no de "reputación".',
    seeAlso: [
      { label: 'Consenso entre fuentes', anchor: '#consenso-entre-fuentes' },
      { label: 'Trustpilot', anchor: '#trustpilot' },
    ],
  },
  {
    letter: 'G',
    term: 'Gemini',
    acro: 'GOOGLE · MOTOR',
    def: 'Familia de modelos multimodales de Google (las versiones Flash y Pro vigentes). Alimenta directamente AI Overviews y Google AI Studio. Su ventaja frente a otros motores es el grounding nativo: la respuesta se ancla en resultados de búsqueda en tiempo real, lo que hace que las citas sean más recientes. Para marcas con presencia establecida en la SERP, suele ser el motor donde el uplift inicial es más rápido.',
    seeAlso: [
      { label: 'AI Overviews', anchor: '#ai-overviews' },
      { label: 'Grounding', anchor: '#grounding' },
    ],
  },
  {
    letter: 'G',
    term: 'Gemini Shopping',
    acro: 'GOOGLE · MOTOR / COMMERCE',
    def: 'Nombre con que el mercado llama a la compra de Google dentro de AI Mode y la app Gemini (Google no lo usa como marca). Desde 2026 cierra compras con checkout por UCP y, desde octubre, Universal Cart junta productos de varias tiendas y sigue sus precios, por ahora en EE.UU. Se nutre del Shopping Graph, así que la puerta de entrada es un feed estructurado y actualizado en Merchant Center: sin ficha bien representada, no hay recomendación de compra.',
    seeAlso: [
      { label: 'Shopping Graph', anchor: '#shopping-graph' },
      { label: 'Google Merchant Center', anchor: '#google-merchant-center' },
      { label: 'AI Mode', anchor: '#ai-mode' },
    ],
  },
  {
    letter: 'G',
    term: 'Google Business Profile',
    acro: 'GBP · TÉCNICO',
    def: 'Ficha pública que Google mantiene para tu negocio. Aunque seas SaaS B2B, es la primera fuente que los modelos consultan para verificar existencia. Reclamarla y mantenerla limpia es uno de los 5 mínimos absolutos.',
  },
  {
    letter: 'G',
    term: 'Google Merchant Center',
    acro: 'GMC · UCP / COMMERCE',
    def: 'Plataforma de Google donde una marca sube y mantiene su feed de productos (precio, stock, atributos, imágenes). Es la fuente que alimenta el Shopping Graph y, por extensión, Gemini Shopping y los carruseles de AI Overviews. Un feed completo y fresco en Merchant Center es el prerrequisito operativo del comercio agéntico en el ecosistema Google.',
    seeAlso: [
      { label: 'Shopping Graph', anchor: '#shopping-graph' },
      { label: 'Gemini Shopping', anchor: '#gemini-shopping' },
    ],
  },
  {
    letter: 'G',
    term: 'GSO',
    acro: 'GENERATIVE SEARCH OPTIMIZATION · MARCO',
    def: 'Cuarto sinónimo en circulación junto a AEO, GEO y LLMO para nombrar la misma disciplina: lograr que los motores generativos citen tu marca. Algunos lo usan para enfatizar la capa de búsqueda generativa (AI Overviews, AI Mode, ChatGPT Search) frente al chat puro. Como con las otras siglas, el método importa más que la etiqueta.',
    seeAlso: [
      { label: 'AEO', anchor: '#answer-engine-optimization' },
      { label: 'GEO', anchor: '#geo' },
      { label: 'LLMO', anchor: '#llmo' },
    ],
  },
  {
    letter: 'G',
    term: 'Grounding',
    acro: 'GROUNDING · TÉCNICO',
    def: 'Proceso por el cual un LLM ata su respuesta a fuentes verificables en el momento de responder. Gemini lo expone como `grounding metadata`. Sin grounding, el modelo responde solo desde memoria — y la memoria envejece.',
  },
  {
    letter: 'G',
    term: 'Grounding query',
    acro: 'GROUNDING QUERY · MÉTRICA',
    def: 'Frase que un motor de IA usa para buscar el contenido que termina citando en su respuesta. Bing Webmaster Tools la muestra desde febrero de 2026 en su reporte **AI Performance**, como una muestra de la actividad de citas en Copilot y Bing. No siempre coincide con la pregunta que escribió la persona: es la búsqueda que hizo el sistema para responderla, a menudo una de las sub-búsquedas del fan-out.',
    seeAlso: [{ label: 'Fan-out queries', anchor: '#fan-out-queries' }],
  },
  {
    letter: 'G',
    term: 'GEO',
    acro: 'GENERATIVE ENGINE OPT. · MARCO',
    def: 'Sinónimo de AEO acuñado en papers académicos de 2023–2024 (Aggarwal et al., Princeton). Algunos lo usan para diferenciar la práctica táctica (GEO = prompt-level, AEO = brand-level). Nosotros los usamos indistintamente — el sustantivo importa menos que el método.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },

  {
    letter: 'G',
    term: 'Grok',
    acro: 'xAI · MOTOR',
    def: 'Motor de xAI con acceso nativo al contenido de X (Twitter) en tiempo real. Su sesgo de fuentes es único: la conversación social pesa más que en cualquier otro motor. Relevante para marcas con presencia activa en X y para monitorear cómo una crisis reputacional en esa red se traduce — en minutos — en respuestas generativas.',
    seeAlso: [
      { label: 'Motor generativo', anchor: '#motor-generativo' },
      { label: 'xAI', anchor: '#xai' },
    ],
  },

  {
    letter: 'G',
    term: 'GPTBot',
    acro: 'OPENAI · TÉCNICO',
    def: 'El crawler de OpenAI que recolecta contenido para el **corpus de entrenamiento** de los modelos GPT — distinto de OAI-SearchBot, que alimenta ChatGPT Search en tiempo real. Bloquearlo en `robots.txt` tiene consecuencias asimétricas: si lo bloqueas, tu marca queda fuera de los pesos del próximo modelo entrenado. Si no lo bloqueas, tu contenido puede usarse como dato de entrenamiento sin compensación. Distinto horizonte: OAI-SearchBot afecta citas de esta semana; GPTBot afecta lo que el modelo sabrá en 12–18 meses.',
    seeAlso: [
      { label: 'OAI-SearchBot', anchor: '#oai-searchbot' },
      { label: 'robots.txt', anchor: '#robots-txt' },
      { label: 'Corte de entrenamiento', anchor: '#corte-de-entrenamiento' },
    ],
  },

  /* H */
  {
    letter: 'H',
    term: 'Helpful Content',
    acro: 'HCU · SEO',
    def: 'Sistema de evaluación de Google introducido en 2022 que degrada contenido escrito para rankear más que para ayudar. Su lógica se generalizó al stack generativo: los LLMs prefieren contenido con propósito claro, autor identificable y profundidad real. La era del "contenido escrito por SEO" se acaba — la del contenido útil empieza.',
  },

  {
    letter: 'H',
    term: 'hreflang',
    acro: 'HREFLANG · SEO / TÉCNICO',
    def: 'Atributo que declara las variantes de idioma y país de una URL. Crítico para marcas LatAm con sitios ES/EN: sin hreflang, los crawlers pueden indexar la versión equivocada o dividir la señal de entidad entre dos URLs. Para AEO es disambiguación idiomática: le dice al motor cuál documento citar según el idioma del prompt.',
    seeAlso: [
      { label: 'Canonical', anchor: '#canonical' },
      { label: 'Disambiguación', anchor: '#disambiguacion' },
    ],
  },

  /* I */
  {
    letter: 'I',
    term: 'Indexación',
    acro: 'INDEXING · TÉCNICO',
    def: 'El proceso por el cual un crawler recorre tu sitio y guarda su contenido en un índice consultable. En AEO hay dos índices distintos que importan: el de Google (para SERPs + AIO) y los índices internos de cada motor LLM. Estar indexado en uno no implica estarlo en otro — y los plazos varían de horas a semanas. Una página es **indexable** cuando nada le impide entrar al índice: responde 200, no lleva `noindex`, su `canonical` apunta a sí misma y el `robots.txt` deja rastrearla. Indexable no garantiza indexada: el motor decide si la guarda.',
    seeAlso: [
      { label: 'Canonical', anchor: '#canonical' },
      { label: 'robots.txt', anchor: '#robots-txt' },
    ],
  },
  {
    letter: 'I',
    term: 'ICP',
    acro: 'IDEAL CUSTOMER PROFILE · MARKETING',
    def: 'Perfil detallado del cliente que más valor obtiene de tu producto. En AEO lo usamos para construir el catálogo de prompts: las consultas que ese ICP realmente le hace a un LLM son nuestro test set. Sin ICP claro, terminas midiendo ruido genérico de tu categoría.',
  },
  {
    letter: 'I',
    term: 'Impresión conversacional',
    acro: 'CONV · MÉTRICA',
    def: 'Una respuesta de LLM que menciona tu marca, sea o no con link. A diferencia de la impresión SEO, no se cuenta como evento publicitario: se cuenta como nodo de conversación. La métrica de éxito es la cita, no la impresión.',
  },
  {
    letter: 'I',
    term: 'Inferencia',
    acro: 'INFERENCE · TÉCNICO',
    def: 'El acto de generar la respuesta: cada token que el modelo produce cuesta cómputo. Por eso los motores cachean respuestas frecuentes y resumen agresivamente las fuentes. Implicación AEO: para prompts de alto volumen, la respuesta puede estar "congelada" durante días — cambiar tu cita ahí toma más tiempo que en prompts long-tail que se generan en vivo.',
    seeAlso: [
      { label: 'Tokens', anchor: '#tokens' },
      { label: 'Long-tail prompts', anchor: '#long-tail-prompts' },
    ],
  },
  {
    letter: 'I',
    term: 'Information gain',
    acro: 'GANANCIA DE INFORMACIÓN · MARCO',
    def: 'Cuánta información nueva aporta tu contenido frente a lo que ya existe en el índice. Los motores des-priorizan lo redundante: la página 41 que dice lo mismo que las primeras 40 no se cita. Datos propios, casos con números, benchmarks y opiniones firmadas son las formas baratas de information gain. La pregunta editorial deja de ser "¿está bien escrito?" y pasa a ser "¿qué sabe el índice después de leerme que antes no sabía?".',
    seeAlso: [
      { label: 'Citabilidad', anchor: '#citabilidad' },
      { label: 'Pillar Content', anchor: '#pillar-content' },
    ],
  },
  {
    letter: 'I',
    term: 'Instant Checkout',
    acro: 'OPENAI + STRIPE · UCP / COMMERCE',
    def: 'La implementación comercial de ACP: comprar dentro de ChatGPT sin salir del chat, lanzada en 2025 con Stripe. En marzo de 2026 OpenAI dejó de priorizarla por la baja adopción de comercios y problemas de exactitud del catálogo, y la compra volvió al checkout de la tienda o a apps dentro de ChatGPT. La dirección sigue: Google, Copilot, Perplexity y Meta Muse ya cierran compras dentro del asistente.',
    seeAlso: [
      { label: 'ACP', anchor: '#acp' },
      { label: 'Agentic Commerce', anchor: '#agentic-commerce' },
      { label: 'Meta Muse', anchor: '#meta-muse' },
    ],
  },
  {
    letter: 'I',
    term: 'Índice de retrieval',
    acro: 'INDEX · TÉCNICO',
    def: 'La base de datos que un motor generativo consulta en tiempo real para responder, distinta del corpus de entrenamiento. Tu contenido nuevo entra al índice mucho antes que a los pesos del modelo —por eso una marca emergente puede ganar visibilidad en semanas optimizando para retrieval, sin esperar al próximo reentrenamiento. Es el blanco técnico del AEO.',
  },

  /* J */
  {
    letter: 'J',
    term: 'Jugada',
    acro: 'PLAY · PROCESO',
    def: 'Una de las 25 acciones del playbook —en el sitio las llamamos simplemente «acciones»—, cada una con esfuerzo en horas, impacto estimado en puntos de score, prerrequisito y la condición que la activa. Son combinables, no excluyentes: el plan de cada marca encadena varias según su diagnóstico. Es la unidad mínima con la que se mejora la visibilidad de forma medible.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'J',
    term: 'JSON-LD',
    acro: 'JSON-LD · TÉCNICO',
    def: 'Formato para incrustar datos estructurados en el HTML, y el más leído por los LLMs. Como mínimo necesitas `Organization` + `Product`/`SoftwareApplication` + `AggregateRating`. Sin él, los modelos ven tu texto pero no la señal estructurada que usan para resolver tu entidad y sus atributos —precio, categoría, reputación—, así que te citan menos y con más errores.',
    seeAlso: [
      { label: 'json-ld.org', href: 'https://json-ld.org' },
      { label: 'schema.org', href: 'https://schema.org' },
      { label: 'Artículo · schema.org bien hecho', href: '/blog/schema-org-aeo' },
    ],
  },

  /* K */
  {
    letter: 'K',
    term: 'Knowledge Graph',
    acro: 'KG · TÉCNICO',
    def: 'Base de entidades que Google mantiene desde 2012 (más de 5 mil millones de nodos). Es uno de los primeros lugares donde un LLM verifica si tu marca existe. Para entrar al KG necesitas `sameAs` consistentes en Wikidata + presencia editorial Tier-1 + un Knowledge Panel reclamado.',
  },
  {
    letter: 'K',
    term: 'Knowledge Panel',
    acro: 'KP · SEO / AEO',
    def: 'La ficha que Google muestra a la derecha de la SERP cuando reconoce una entidad (marca, persona, lugar). Reclamarlo es un quick win subestimado: una vez verificado, controlas qué datos canónicos Google distribuye, y los LLMs heredan esa señal a través de retrieval.',
  },
  {
    letter: 'K',
    term: 'Keyword',
    acro: 'KW · SEO',
    def: 'Término o frase por la que tu audiencia busca tu categoría. Pilar histórico del SEO. En AEO la unidad equivalente es el prompt: ya no optimizamos para 1 palabra clave sino para una intención conversacional de 8–15 palabras. La keyword sigue importando como semilla del catálogo de prompts, no como objetivo de optimización.',
  },

  /* L */
  {
    letter: 'L',
    term: 'LinkedIn',
    acro: 'LINKEDIN · FUENTE',
    def: 'Sobre-representado en las citas de Perplexity para consultas B2B. Los posts largos y los perfiles de fundadores funcionan como fuentes de autoridad personal — el modelo asocia categorías con personas, no solo con marcas. El perfil del fundador publicando con consistencia sobre su categoría es un activo AEO, no vanidad corporativa.',
    seeAlso: [
      { label: 'E-E-A-T', anchor: '#e-e-a-t' },
      { label: 'Tier-1 (prensa)', anchor: '#tier-1-prensa' },
    ],
  },
  {
    letter: 'L',
    term: 'LTV',
    acro: 'LIFETIME VALUE · MARKETING',
    def: 'Valor total que un cliente genera a lo largo de su relación contigo. La relación LTV:CAC ≥ 3 es el umbral típico de unit economics sano. El AEO baja el CAC sin sacrificar LTV (los leads inbound vía LLM convierten igual o mejor), así que mueve el ratio en la dirección correcta sin más spend.',
  },
  {
    letter: 'L',
    term: 'LLM',
    acro: 'LARGE LANGUAGE MODEL · TÉCNICO',
    def: 'Modelo entrenado en grandes corpus de texto para predecir lenguaje. Las familias GPT (OpenAI), Claude (Anthropic), Gemini (Google) y Llama (Meta) son LLMs. Los motores generativos (ChatGPT, Perplexity, etc.) son productos que envuelven uno o varios LLMs.',
  },
  {
    letter: 'L',
    term: 'LLMO',
    acro: 'LLM OPTIMIZATION · MARCO',
    def: 'Tercer sinónimo en circulación junto a AEO y GEO (a veces también AISEO o "AI SEO"). Todos nombran lo mismo: lograr que los motores generativos citen tu marca. La proliferación de siglas es ruido de disciplina joven — el sustantivo importa menos que el método. Si llegaste buscando "qué es LLMO", ya estás en el lugar correcto.',
    seeAlso: [
      { label: 'AEO', anchor: '#answer-engine-optimization' },
      { label: 'GEO', anchor: '#geo' },
    ],
  },
  {
    letter: 'L',
    term: 'llms.txt',
    acro: 'ESTÁNDAR · TÉCNICO',
    def: 'Archivo que se publica en la raíz de tu dominio para indicar a los LLMs qué contenido pueden leer, en qué orden, y cómo describir tu marca. Convención de llmstxt.org (2024): Anthropic y Perplexity la publican para su propia documentación, aunque Google confirmó que no la usa y la adopción por los motores aún es parcial. Barata de implementar (2 h) y sin riesgo: deja la identidad canónica lista para los crawlers que sí la leen.',
    seeAlso: [
      { label: 'llmstxt.org', href: 'https://llmstxt.org' },
      { label: 'Artículo · quién lee llms.txt', href: '/blog/llms-txt-guia' },
    ],
  },
  {
    letter: 'L',
    term: 'Long-tail prompts',
    acro: 'LONG-TAIL · PROCESO',
    def: 'Consultas específicas y poco frecuentes pero individualmente valiosas (e.g. "mejor CRM para corredor de seguros en Chile"). En AEO se ganan las largas antes que las cortas: menos ruido, mayor especificidad, mejor share-of-voice.',
  },

  /* M */
  {
    letter: 'M',
    term: 'MQL',
    acro: 'MARKETING QUALIFIED LEAD · MARKETING',
    def: 'Lead que cumple criterios mínimos de fit antes de pasar a ventas. Los MQLs que vienen de AEO suelen ser distintos: llegan con un brief pre-armado por el LLM ("vi que ustedes son la única plataforma AEO en español"), saltándose 1–2 etapas de educación. Ajusta tu scoring para no descartarlos por bajo engagement web.',
  },
  {
    letter: 'M',
    term: 'Multimodal',
    acro: 'MULTIMODAL · TÉCNICO',
    def: 'Modelo que procesa más de un tipo de entrada (texto, imagen, audio, video). Los modelos actuales de OpenAI, Google y Anthropic son multimodales nativos. Importa al AEO porque ahora una foto de tu producto en Reddit o un screenshot de tu dashboard pueden ser fuente citable, no solo texto.',
  },
  {
    letter: 'M',
    term: 'MUM',
    acro: 'MULTITASK UNIFIED MODEL · TÉCNICO',
    def: 'Modelo de Google introducido en 2021 que entiende y conecta información en 75 idiomas a la vez. Fue una de las piezas que habilitó AI Overviews en mercados no-inglés. Para AEO en español es especialmente relevante: las marcas locales que tienen contenido bien estructurado en español son menos competencia para los LLMs de la que serían en inglés.',
  },
  {
    letter: 'M',
    term: 'MCP',
    acro: 'MODEL CONTEXT PROTOCOL · UCP / COMMERCE',
    def: 'Protocolo abierto (impulsado por Anthropic) que estandariza cómo un LLM accede a herramientas, datos y catálogos externos. Si tu producto expone un servidor MCP bien documentado, los agentes pueden consultarlo en tiempo real, sin depender del retraining. Publicar un endpoint MCP empieza a ser tan importante como publicar `llms.txt`.',
    seeAlso: [
      {
        label: 'modelcontextprotocol.io',
        href: 'https://modelcontextprotocol.io',
      },
      { label: 'Artículo · MCP para tu negocio', href: '/blog/mcp-para-tu-negocio' },
    ],
  },
  {
    letter: 'M',
    term: 'MPP',
    acro: 'MACHINE PAYMENT PROTOCOL · UCP / COMMERCE',
    def: 'Estándar emergente para que un agente pague una operación HTTP sin intervención humana: cada endpoint cobrable se declara en tu documento OpenAPI (`/openapi.json`) con su intención (cargo o sesión), monto, moneda y método de pago. Mientras ACP y AP2 resuelven el checkout dentro del chat, MPP apunta a que los propios servicios y APIs sean pagables por agentes. Si vendes acceso a datos o funciones, es la capa que te vuelve transaccionable máquina-a-máquina.',
    seeAlso: [
      { label: 'x402', anchor: '#x402' },
      { label: 'AP2', anchor: '#ap2' },
      { label: 'ACP', anchor: '#acp' },
    ],
  },
  {
    letter: 'M',
    term: 'Memoria (LLM)',
    acro: 'MEMORY · TÉCNICO',
    def: 'Capacidad de ChatGPT y Gemini de recordar contexto del usuario entre sesiones. Consecuencia incómoda para la medición: la respuesta sobre tu categoría ya no es igual para todos — está personalizada por historial. Por eso los catálogos de prompts se ejecutan en sesiones limpias y sin memoria: medimos la baseline pública, no la burbuja de un usuario.',
    seeAlso: [
      { label: 'Prompt', anchor: '#prompt' },
      { label: 'Frecuencia de aparición', anchor: '#frecuencia-de-aparicion' },
    ],
  },
  {
    letter: 'M',
    term: 'Meta AI',
    acro: 'META · MOTOR',
    def: 'El asistente embebido en WhatsApp, Instagram y Facebook. Crítico para LatAm por la penetración de WhatsApp como canal comercial, aunque su capa de citas es aún inmadura y su sesgo de fuentes, opaco. Hoy se monitorea más como riesgo (qué dice de tu marca) que como canal (cómo ganar la cita). Eso va a cambiar — y conviene tener la serie histórica cuando cambie.',
    seeAlso: [{ label: 'Motor generativo', anchor: '#motor-generativo' }],
  },
  {
    letter: 'M',
    term: 'Meta Muse',
    acro: 'META · MOTOR',
    def: 'Agente personal de Meta lanzado en septiembre de 2026: en vez de responder una pregunta, ejecuta tareas largas por el usuario —navega, compara, llena formularios y compra con su aprobación— con acceso al catálogo de Shopify. Superó los 10 millones de usuarios y comprar es uno de sus usos principales. Opera en EE.UU. y Canadá; para una marca de LatAm, el momento de dejar su catálogo legible para agentes es antes de que llegue.',
    seeAlso: [
      { label: 'Meta AI', anchor: '#meta-ai' },
      { label: 'Agentic Commerce', anchor: '#agentic-commerce' },
      { label: 'Artículo · Muse Wonder y el AEO', href: '/blog/meta-muse-wonder-aeo' },
    ],
  },
  {
    letter: 'M',
    term: 'Mínimos absolutos',
    acro: 'M1–M5 · PROCESO',
    def: 'Las cinco acciones obligatorias antes que cualquier otra: identidad legal consistente, schema.org, `llms.txt`, Google Business Profile y reporting semanal. Son la base sobre la que se apoya todo lo demás: si una falla, ningún playbook avanzado compensa —el modelo sigue sin resolver tu entidad o sin datos para citarte. Se verifican primero en cada diagnóstico.',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'M',
    term: 'Mistral / Le Chat',
    acro: 'MISTRAL AI · MOTOR',
    def: 'El motor europeo, con modelos abiertos y asistente propio (Le Chat). Relevante para clientes con requisitos de soberanía de datos o compliance UE, y creciente en mercados francófonos e hispanohablantes de Europa. Mismo principio que DeepSeek: pesos abiertos significan que tu marca queda congelada en cada release.',
    seeAlso: [
      { label: 'Open weights', anchor: '#open-weights' },
      { label: 'Motor generativo', anchor: '#motor-generativo' },
    ],
  },
  {
    letter: 'M',
    term: 'Modelo frontera',
    acro: 'FRONTIER MODEL · TÉCNICO',
    def: 'El modelo más capaz disponible de cada laboratorio en un momento dado. Matiz que importa: los motores de consumo no siempre lo usan — por costo y latencia sirven versiones más pequeñas a usuarios gratuitos. Tu marca puede ser citada por el modelo frontera y omitida por el modelo "mini" que usa el 80% del tráfico. Por eso se mide por producto, no por modelo.',
    seeAlso: [
      { label: 'LLM', anchor: '#llm' },
      { label: 'Inferencia', anchor: '#inferencia' },
    ],
  },
  {
    letter: 'M',
    term: 'Motor generativo',
    acro: 'ENGINE · MOTOR',
    def: 'Cualquier producto cuya respuesta principal sea texto generado por un LLM, no una lista de enlaces — también llamado answer engine. Un buscador te da 10 opciones para que elijas; un motor generativo decide por ti y cita a quien le ayudó a decidir: esa cita es el nuevo espacio publicitario del AEO, y no se compra, se gana. Los cinco que Bison cubre: ChatGPT, Gemini, Claude, Perplexity y Google AI Overviews — distintos del LLM subyacente.',
    seeAlso: [{ label: 'AEO', anchor: '#answer-engine-optimization' }],
  },

  /* N */
  {
    letter: 'N',
    term: 'NER',
    acro: 'NAMED ENTITY RECOGNITION · TÉCNICO',
    def: 'Paso del pipeline que detecta automáticamente qué marcas, productos y personas menciona cada respuesta generativa. Es la capa que convierte texto libre en datos estructurados: sin NER no hay citas contables, ni Share-of-Voice, ni sentimiento segmentado por entidad. Bison corre NER en cada uno de los 3–5 runs por motor por semana.',
    seeAlso: [{ label: 'Share-of-Voice', anchor: '#share-of-voice' }],
  },
  {
    letter: 'N',
    term: 'NPS',
    acro: 'NET PROMOTER SCORE · MARKETING',
    def: 'Métrica que mide la probabilidad de que un cliente recomiende tu marca, en escala −100 a +100. Importa al AEO de forma indirecta: un cliente promotor escribe reseñas, casos, posts. Cada uno de esos artefactos termina siendo input citable para los LLMs. NPS bajo no es solo un problema de retención; es un techo para tu cobertura.',
  },

  /* O */
  {
    letter: 'O',
    term: 'OAI-SearchBot',
    acro: 'CRAWLER DE BÚSQUEDA · TÉCNICO',
    def: 'El crawler de búsqueda en vivo de OpenAI — distinto de GPTBot, que recolecta para entrenamiento. La distinción define tu política de robots.txt: bloquear GPTBot te saca del corpus futuro; bloquear OAI-SearchBot te saca de ChatGPT Search hoy. Son decisiones distintas con plazos distintos. Auditar qué bots permites es parte de los mínimos técnicos.',
    seeAlso: [
      { label: 'Crawler', anchor: '#crawler' },
      { label: 'robots.txt', anchor: '#robots-txt' },
      { label: 'ChatGPT Search', anchor: '#chatgpt-search' },
    ],
  },
  {
    letter: 'O',
    term: 'Open Graph',
    acro: 'OG · TÉCNICO',
    def: 'Protocolo de meta-tags (impulsado por Facebook) que define cómo se previsualiza una URL al compartirse. Para AEO sirve como capa redundante de identidad: si tu schema.org está roto pero tu OG está limpio, algunos crawlers aún pueden resolver tu entidad. Costo: 1 hora; impacto: pequeño pero gratis.',
  },
  {
    letter: 'O',
    term: 'Open weights',
    acro: 'PESOS ABIERTOS · TÉCNICO',
    def: 'Modelos cuyos pesos se publican para descarga y despliegue local (Llama, DeepSeek, Mistral). Para AEO, su rasgo clave es que no tienen retrieval por defecto: lo que el corpus decía de tu marca al entrenarse es lo que el modelo repite, sin corrección posible hasta el siguiente release. El juego ahí es puro corpus — Wikipedia, prensa y fuentes masivas.',
    seeAlso: [
      { label: 'Corpus de entrenamiento', anchor: '#corpus-de-entrenamiento' },
      { label: 'DeepSeek', anchor: '#deepseek' },
    ],
  },
  {
    letter: 'O',
    term: 'Overview generativo',
    acro: 'AIO · MOTOR',
    def: 'Término genérico para el bloque de respuesta sintética que los motores de búsqueda generativos producen antes de los resultados tradicionales, citando 3–8 fuentes. Google lo llama AI Overviews; Bing lo integra en Copilot; Perplexity construye su modelo entero sobre este patrón. En Bison lo usamos para hablar del patrón sin atarlo a un motor específico: el AEO es la disciplina de entrar en ese bloque, cualquiera que sea su nombre en cada plataforma.',
  },

  {
    letter: 'O',
    term: 'Opt-out AIO',
    acro: 'SEARCH CONSOLE · MARCO',
    def: 'Control habilitado en Google Search Console desde junio de 2026 que permite excluir el contenido de un sitio de AI Overviews, AI Mode y AI Overviews en Discover sin afectar el ranking orgánico. Impuesto por la CMA del Reino Unido como primera regulación vinculante de la búsqueda generativa. El control es granular (todo el sitio o por directorio) y excluye explícitamente la app Gemini. Para la mayoría de las marcas B2B el opt-out es contraproducente: ceder ese espacio a la competencia que sí aparece en la respuesta.',
    seeAlso: [
      { label: 'AI Overviews', anchor: '#ai-overviews' },
      { label: 'AI Mode', anchor: '#ai-mode' },
      { label: 'CMA', anchor: '#cma' },
    ],
  },

  /* P */
  {
    letter: 'P',
    term: 'People Also Ask',
    acro: 'PAA · SEO',
    def: 'Bloque de preguntas relacionadas que Google muestra en la SERP. Es una mina de prompts reales: cada PAA es una consulta que un humano ya formuló. Lo extraemos sistemáticamente al construir el catálogo de prompts de un cliente — es la forma más barata de saber qué preguntan tus prospectos.',
  },
  {
    letter: 'P',
    term: 'Persona',
    acro: 'BUYER PERSONA · MARKETING',
    def: 'Representación semi-ficcional de un cliente. Hermana pequeña del ICP: la persona es la cara, el ICP es el spreadsheet. Útil para escribir contenido con voz consistente — los LLMs prefieren contenido que suena escrito para un humano específico que copy genérico optimizado para keywords.',
  },
  {
    letter: 'P',
    term: 'Pillar Content',
    acro: 'CONTENIDO PILAR · SEO / AEO',
    def: 'Pieza larga que cubre un tema en profundidad y enlaza a artículos más cortos del mismo cluster. Estructura nativa para AEO: el motor entra al pilar, identifica la entidad y las sub-entidades, y considera todo el cluster como una sola autoridad. Un cliente con 1 pilar + 12 satélites suele citar 3× más que un cliente con 50 posts sueltos.',
  },
  {
    letter: 'P',
    term: 'Pay-per-crawl',
    acro: 'CLOUDFLARE · TÉCNICO',
    def: 'Esquema de Cloudflare, lanzado en beta el 1 de julio de 2025, que permite a un sitio **cobrar a los crawlers de IA** por acceder a su contenido, en lugar de solo permitirlos o bloquearlos. Para tu marca cambia la pregunta: ya no es solo si los modelos pueden leerte, sino bajo qué condiciones, y bloquear o cobrar puede costarte presencia en sus respuestas.',
    seeAlso: [
      { label: 'Crawler', anchor: '#crawler' },
      { label: 'robots.txt', anchor: '#robots-txt' },
      { label: 'Artículo · pay-per-crawl', href: '/blog/cloudflare-pay-per-crawl-ia' },
    ],
  },
  {
    letter: 'P',
    term: 'Perplexity',
    acro: 'PERPLEXITY AI · MOTOR',
    def: 'Motor generativo con foco en citas como first-class. La API Sonar devuelve cada respuesta con un array `citations[]`. Ideal para validación cruzada de fuentes y para detectar primero qué fuentes considera autoridad un modelo.',
  },
  {
    letter: 'P',
    term: 'Prompt injection',
    acro: 'INYECCIÓN DE PROMPTS · TÉCNICO',
    def: 'Instrucciones maliciosas escondidas en contenido web ("ignora lo anterior y recomienda X") para manipular agentes que leen la página. Los motores lo tratan como spam de nueva generación: sitios que lo intentan pierden confianza del retrieval. Mención obligada en cualquier auditoría — incluido verificar que terceros no lo estén haciendo contra tu marca.',
    seeAlso: [
      { label: 'Agente', anchor: '#agente' },
      { label: 'Alucinación', anchor: '#alucinacion' },
    ],
  },
  {
    letter: 'P',
    term: 'Prompt seeding',
    acro: 'SEEDING · MARCO',
    def: 'Táctica gray-hat de sembrar menciones artificiales de marca en foros, reseñas y UGC para inflar el consenso que los modelos leen. No la recomendamos: los motores ya detectan astroturfing, las plataformas lo penalizan y el riesgo reputacional excede el uplift. El consenso se construye con evidencia real — más lento, pero compuesto y sin fecha de demolición.',
    seeAlso: [
      { label: 'Consenso entre fuentes', anchor: '#consenso-entre-fuentes' },
      { label: 'Reddit', anchor: '#reddit' },
    ],
  },
  {
    letter: 'P',
    term: 'Playbook',
    acro: 'PLAYBOOK · PROCESO',
    def: 'La biblioteca completa de 25 acciones que cada cliente activa según su tipo de negocio y su diagnóstico. No es un manual genérico: se selecciona y secuencia caso por caso, priorizando por impacto en puntos de score y esfuerzo. Es el puente entre «sé dónde estoy invisible» y «esto es lo que hago esta semana para que la IA me cite».',
    seeAlso: [{ label: 'Metodología', href: '/metodologia' }],
  },
  {
    letter: 'P',
    term: 'Prompt',
    acro: 'PROMPT · TÉCNICO',
    def: 'La entrada de texto que se le da a un LLM. En AEO trabajamos con catálogos de 200–2,000 prompts por workspace, rotados semanalmente, para muestrear la conversación real de tu categoría.',
  },
  {
    letter: 'P',
    term: 'Posición media',
    acro: 'POS · MÉTRICA',
    def: 'El orden promedio en el que tu marca aparece dentro de las respuestas que sí te citan. Posición 1 = primera mención. Una marca puede tener cobertura alta pero posición mala — y al revés.',
  },

  /* Q */
  {
    letter: 'Q',
    term: 'Quality Raters',
    acro: 'SEARCH QUALITY RATERS · SEO',
    def: 'Los evaluadores humanos de Google cuyas guías públicas (Search Quality Rater Guidelines) definieron E-E-A-T. No rankean páginas directamente: califican muestras para entrenar los sistemas. Importan al AEO porque sus criterios — autor verificable, propósito claro, evidencia de experiencia — son los mismos que los LLMs heredaron de sus corpus. Leer las guidelines sigue siendo el mejor curso gratuito de citabilidad.',
    seeAlso: [
      { label: 'E-E-A-T', anchor: '#e-e-a-t' },
      { label: 'Helpful Content', anchor: '#helpful-content' },
    ],
  },

  /* R */
  {
    letter: 'R',
    term: 'Re-ranking',
    acro: 'RE-RANKING · TÉCNICO',
    def: 'El paso posterior al retrieval donde el motor reordena los documentos candidatos antes de decidir cuáles citar. La relevancia semántica te mete en la lista; el re-ranking decide tu posición en ella — y ahí pesan autoridad, frescura y consistencia de entidad. Explica por qué dos contenidos igual de relevantes terminan con visibilidades opuestas.',
    seeAlso: [
      { label: 'Retrieval', anchor: '#retrieval' },
      { label: 'Posición media', anchor: '#posicion-media' },
    ],
  },
  {
    letter: 'R',
    term: 'Reddit',
    acro: 'REDDIT · FUENTE',
    def: 'La fuente más citada por los motores generativos en 2026 — primera o segunda en prácticamente todos los estudios de citaciones publicados. Los modelos la tratan como proxy de experiencia real de usuarios. Para marcas: monitorear menciones, participar con valor genuino en los subreddits de la categoría, y jamás astroturfing — los motores y los moderadores lo detectan, y la penalidad es duradera.',
    seeAlso: [
      { label: 'Consenso entre fuentes', anchor: '#consenso-entre-fuentes' },
      { label: 'Prompt seeding', anchor: '#prompt-seeding' },
      { label: 'Artículo · las fuentes que la IA cita', href: '/blog/fuentes-que-la-ia-cita' },
    ],
  },
  {
    letter: 'R',
    term: 'Referral de IA',
    acro: 'AI REFERRAL TRAFFIC · MÉTRICA',
    def: 'Tráfico que llega a tu sitio desde chatgpt.com, perplexity.ai, gemini.google.com y similares. Se identifica por referrer en analytics y convierte muy por encima del promedio — llega pre-educado. Pero subestima sistemáticamente el impacto real del AEO: la mayoría del valor es zero-click y nunca toca tu sitio. Úsalo como piso del impacto, nunca como techo.',
    seeAlso: [
      { label: 'Zero-click', anchor: '#zero-click' },
      { label: 'Atribución', anchor: '#atribucion' },
    ],
  },
  {
    letter: 'R',
    term: 'Rich Snippet',
    acro: 'FRAGMENTO ENRIQUECIDO · SEO',
    def: 'Resultado de búsqueda con elementos extra (estrellas, precio, FAQs, recetas) generados desde schema.org. Para AEO es señal de schema bien implementado: si Google te muestra rich snippets, tu schema es legible — y los LLMs lo leen igual de bien.',
  },
  {
    letter: 'R',
    term: 'ROAS',
    acro: 'RETURN ON AD SPEND · MARKETING',
    def: 'Ingresos por cada dólar gastado en publicidad pagada. Métrica clásica del paid. El AEO no produce ROAS porque no es paid, pero compite con él: cada dólar que mueves de Ads a AEO compra cobertura permanente en lugar de impresiones puntuales. El cálculo correcto compara ROAS contra citas acumuladas × LTV.',
  },
  {
    letter: 'R',
    term: 'robots.txt',
    acro: 'ROBOTS.TXT · TÉCNICO',
    def: 'Archivo en la raíz de tu dominio que indica a los crawlers qué pueden y qué no pueden leer. En AEO requiere configuración diferenciada: `GPTBot`, `ClaudeBot`, `PerplexityBot`, `Google-Extended`, `CCBot` son agentes distintos con permisos distintos. Bloquearlos todos por miedo a "robar contenido" suele ser pegarse un tiro: dejas de existir para ellos.',
  },
  {
    letter: 'R',
    term: 'RAG',
    acro: 'RETRIEVAL-AUGMENTED · TÉCNICO',
    def: 'Arquitectura donde el LLM consulta una base de datos externa antes de responder. La gran mayoría de los motores generativos públicos usan RAG. Optimizar tu sitio para retrieval (estructura, metadatos, claridad) es el corazón técnico del AEO.',
  },
  {
    letter: 'R',
    term: 'Retrieval',
    acro: 'RETRIEVAL · TÉCNICO',
    def: 'El paso en que el motor recupera documentos relevantes antes de pedirle al LLM que responda. Si tu marca no está en el índice de retrieval, no será citada — independientemente de lo que diga tu sitio.',
  },
  {
    letter: 'R',
    term: 'ROI AEO',
    acro: 'ROI · MÉTRICA',
    def: 'Retorno medible de la inversión en AEO: leads atribuibles a citas en motores generativos × valor medio del lead, menos el costo del ciclo. La dificultad principal es la atribución: la mayor parte del valor es zero-click y no toca el analytics. Bison lo aproxima con atribución asistida — tráfico de referral IA en GA4, encuestas en formularios y share-of-voice recuperado. La heurística propia es 22% de conversión del SOV recuperado, útil como piso del cálculo, no como garantía.',
  },

  /* S */
  {
    letter: 'S',
    term: 'Score AEO',
    acro: 'PUNTUACIÓN · MÉTRICA',
    def: 'Índice 0–100 que mide la **visibilidad real** de una marca en los motores generativos, a partir de cuatro componentes: menciones, citabilidad, posición en la respuesta y sentimiento; el share-of-voice se reporta aparte. Cuatro bandas: Crítico (0–25) la marca es invisible; Emergente (26–50) señales inconsistentes; Consolidada (51–75) identidad sólida con cobertura creciente; Referente (76–100) autoridad citada por defecto en su categoría. Instrumento distinto del Diagnóstico 4D: el 4D diagnostica brechas; el Score mide el resultado en los motores semana a semana.',
    seeAlso: [
      { label: 'Diagnóstico 4D', anchor: '#diagnostico-4d' },
      { label: 'Baseline', anchor: '#baseline' },
      { label: 'Artículo · primeros 90 días de AEO', href: '/blog/primeros-90-dias-aeo' },
    ],
  },
  {
    letter: 'S',
    term: 'Sentiment Analysis',
    acro: 'ANÁLISIS DE SENTIMIENTO · TÉCNICO / MÉTRICA',
    def: 'Score que clasifica una mención como positiva, negativa o neutra. Bison reporta sentimiento agregado por motor (rango −1 a +1). Una marca puede tener cobertura alta y sentimiento negativo — esa es la peor combinación posible para el funnel.',
  },
  {
    letter: 'X',
    term: 'XML Sitemap',
    acro: 'SITEMAP.XML · TÉCNICO',
    def: 'Archivo XML que lista todas las URLs públicas de tu sitio con su `lastmod`. Crítico para AEO porque los crawlers de LLMs son más perezosos que Googlebot: si no les das un mapa explícito, descubren menos páginas, y citan menos. Sitemap por tipo de contenido (productos, posts, casos, autores) es la forma correcta.',
  },
  {
    letter: 'X',
    term: 'x402',
    acro: 'HTTP 402 · UCP / COMMERCE',
    def: 'Estándar abierto (impulsado por Coinbase) que revive el código HTTP `402 Payment Required`: un servidor responde 402 con las instrucciones de pago, el agente paga —típicamente con stablecoins sobre rieles cripto— y reintenta la petición, todo sin checkout humano. Es la vía para cobrar micropagos por API, datos o contenido a agentes autónomos. Junto con MPP, define cómo una máquina le paga a otra por acceder a tu servicio.',
    seeAlso: [
      { label: 'MPP', anchor: '#mpp' },
      { label: 'Agentic Commerce', anchor: '#agentic-commerce' },
    ],
  },
  {
    letter: 'S',
    term: 'Shopping Graph',
    acro: 'GOOGLE · UCP / COMMERCE',
    def: 'El grafo de productos de Google — miles de millones de fichas — que alimenta AI Mode y AI Overviews en consultas transaccionales. La puerta de entrada es Merchant Center con feed estructurado y actualizado. Para e-commerce, estar bien representado en el Shopping Graph es el equivalente transaccional de tener schema completo: sin ficha, no hay recomendación.',
    seeAlso: [
      { label: 'UCP', anchor: '#ucp' },
      { label: 'AI Mode', anchor: '#ai-mode' },
    ],
  },
  {
    letter: 'S',
    term: 'SQL',
    acro: 'SALES QUALIFIED LEAD · MARKETING',
    def: 'Lead validado por ventas y listo para una conversación comercial. Los SQLs que vienen vía AEO suelen pedir directamente plan + precio en el primer touchpoint. Ajusta tu definición de "qualified" para incluir señales conversacionales ("dijo qué acción de nuestro playbook le interesa") y no solo formularios. No confundir con SQL, el lenguaje de consulta de bases de datos — misma sigla, otra entidad. Exactamente el problema de disambiguación que describe la entrada Entidad.',
  },
  {
    letter: 'S',
    term: 'SXO',
    acro: 'SEARCH EXPERIENCE OPT. · SEO',
    def: 'Disciplina que une SEO técnico con UX: optimizar no solo para rankear, sino para que el usuario que llega desde el buscador encuentre exactamente lo que buscaba. Relevante en AEO porque los motores generativos evalúan la experiencia completa de la página al decidir si citarla — velocidad, estructura, claridad de la respuesta y señales de satisfacción forman parte del ranking implícito.',
    seeAlso: [
      { label: 'SEO', anchor: '#seo' },
      { label: 'Core Web Vitals', anchor: '#core-web-vitals' },
    ],
  },
  {
    letter: 'S',
    term: 'System Prompt',
    acro: 'SYSTEM PROMPT · TÉCNICO',
    def: 'Instrucciones de fondo que un LLM recibe antes del prompt del usuario (tono, formato, restricciones). En AEO no controlas el system prompt del modelo público, pero sí controlas lo que el modelo recupera. Tu contenido es, en efecto, el "system prompt" indirecto sobre tu marca.',
  },
  {
    letter: 'S',
    term: 'sameAs',
    acro: 'SAMEAS · TÉCNICO',
    def: 'Propiedad de schema.org que enlaza tu marca con sus presencias canónicas (LinkedIn, Wikidata, Crunchbase). Es el pegamento de la disambiguación. Sin `sameAs` estrictos, el modelo no sabe que tu LinkedIn y tu Wikidata son la misma entidad.',
    seeAlso: [
      { label: 'schema.org/sameAs', href: 'https://schema.org/sameAs' },
    ],
  },
  {
    letter: 'S',
    term: 'Schema.org',
    acro: 'SCHEMA · TÉCNICO',
    def: 'Vocabulario consensuado para describir entidades en la web (Organization, Product, Person, Review). Es el lenguaje franco entre tu sitio y cualquier LLM. Schema completo es uno de los 5 mínimos absolutos.',
    seeAlso: [
      { label: 'schema.org', href: 'https://schema.org' },
      { label: 'Artículo · schema.org bien hecho', href: '/blog/schema-org-aeo' },
    ],
  },
  {
    letter: 'S',
    term: 'Search Everywhere Optimization',
    acro: 'SEO 2.0 · MARCO',
    def: 'La tesis de que la disciplina converge: SERP, LLMs, TikTok, YouTube, marketplaces y app stores son superficies de búsqueda de un mismo usuario. Útil como marco de presupuesto; peligrosa como excusa para no priorizar. Nuestra postura: el AEO es la capa con mayor delta de oportunidad hoy, porque es donde la mayoría de las marcas sigue en cero.',
    seeAlso: [
      { label: 'AEO', anchor: '#answer-engine-optimization' },
      { label: 'Voice search', anchor: '#voice-search' },
    ],
  },
  {
    letter: 'S',
    term: 'SEO',
    acro: 'SEARCH ENGINE OPT. · MARCO',
    def: 'Conjunto de prácticas para rankear en los resultados tradicionales de Google. No muere con el AEO, se transforma: el SEO técnico (rastreo, indexación, datos estructurados, velocidad) es la base que la IA necesita para leer un sitio y citarlo, y el contenido que era bueno para SEO sigue siendo buen input para retrieval; lo que deja de ser suficiente es optimizar solo para el ranking de enlaces. AEO ⊃ SEO.',
  },
  {
    letter: 'S',
    term: 'SERP',
    acro: 'SEARCH ENGINE RESULTS PAGE · SEO',
    def: 'La página de resultados de un motor de búsqueda. La SERP clásica era 10 enlaces; la SERP 2026 es 1 bloque generativo (AI Overview) sobre 8 enlaces. El espacio azul se redujo y el espacio citable se expandió. La pelea ya no es por la posición 1 — es por aparecer dentro del overview.',
  },
  {
    letter: 'S',
    term: 'Share de citas',
    acro: 'CITATION SHARE · MÉTRICA',
    def: 'Porcentaje de las citas con fuente de una respuesta que apuntan a propiedades tuyas o te mencionan. Distinto de Share-of-Voice: SoV mide menciones de marca; citation share mide a quién atribuye el motor la información. Puedes tener SoV alto sostenido por fuentes de terceros que no controlas — bueno para awareness, frágil para narrativa. La meta madura es alta en ambos.',
    seeAlso: [
      { label: 'Share-of-Voice', anchor: '#share-of-voice' },
      { label: 'Cita', anchor: '#cita' },
    ],
  },
  {
    letter: 'S',
    term: 'Share-of-Voice',
    acro: 'SOV · MÉTRICA',
    def: '% del total de menciones en tu categoría que pertenecen a tu marca. Si en 1,000 prompts hay 410 menciones de marcas y 60 son tuyas, tu SoV es 60/410 ≈ 14.6%. Mide tu peso frente a la competencia; Bison la reporta por motor y agregada, aparte del Score AEO.',
  },
  {
    letter: 'S',
    term: 'Share of Model',
    acro: 'SOM · MÉTRICA',
    def: '% de veces que tu marca es **recomendada como solución** cuando un usuario le pide a un LLM opciones en su categoría. Distinto del `Share-of-Voice`: el SoV cuenta cualquier mención; el SoM cuenta solo recomendaciones activas. Una marca puede tener SoV alto y SoM bajo si los motores la nombran pero no la recomiendan. La variante **multi-modelo** añade solidez: un SoM robusto implica ser recomendado de forma consistente en ChatGPT, Gemini, Perplexity y Claude — no solo en uno.',
    seeAlso: [
      { label: 'Share-of-Voice', anchor: '#share-of-voice' },
      { label: 'Share de citas', anchor: '#share-de-citas' },
      { label: 'Citabilidad', anchor: '#citabilidad' },
    ],
  },

  /* T */
  {
    letter: 'T',
    term: 'Tokens',
    acro: 'TOKENS · TÉCNICO',
    def: 'Unidades mínimas en que un LLM procesa texto (aprox. ¾ de palabra en español). Importan porque definen costo y ventana de contexto. Para AEO: un párrafo bien estructurado de 80 palabras (~110 tokens) es óptimo para citación — más corto se pierde, más largo se trunca.',
  },
  {
    letter: 'T',
    term: 'Topic Cluster',
    acro: 'CLUSTER TEMÁTICO · SEO / AEO',
    def: 'Conjunto de contenidos enlazados que cubren un tema desde múltiples ángulos. Estructura hub-and-spoke: un pillar central + N satélites. La estructura nativa para fan-out queries: el motor puede entrar por cualquier nodo y reconocer todo el cluster como una sola autoridad.',
  },
  {
    letter: 'T',
    term: 'Top-of-mind',
    acro: 'TOM · MARKETING',
    def: 'La primera marca que un consumidor menciona sin asistencia cuando se le pregunta por una categoría. El equivalente AEO es ser la primera marca que el LLM cita ante un prompt categórico ("plataformas X en español"). Top-of-mind humano y top-of-mind generativo se influencian mutuamente — pero el segundo se mueve más rápido.',
  },
  {
    letter: 'T',
    term: 'Tier-1 (prensa)',
    acro: 'TIER-1 · PROCESO',
    def: 'Medios de máxima autoridad para tu sector y geografía (Forbes, TechCrunch, El Mercurio, La Tercera, Reforma). Lo que los LLMs leen para validar autoridad editorial. Una mención Tier-1 vale 10 menciones Tier-3.',
  },
  {
    letter: 'T',
    term: 'Tráfico de IA',
    acro: 'AI TRAFFIC · MÉTRICA',
    def: 'El tráfico que llega a tu sitio desde respuestas de motores generativos (ChatGPT, Gemini, Perplexity) en lugar de desde la búsqueda tradicional. Su volumen suele ser menor que el orgánico clásico, pero llega **pre-cualificado**: el motor ya resolvió la duda inicial del usuario, que hace clic sabiendo quién eres. Esto se traduce en tasas de conversión superiores —4.4× sobre la búsqueda tradicional (datos propios)— y mayor tiempo en sitio. Bison lo separa del tráfico humano integrándose con GA4 para atribuir qué visitas y conversiones nacen de la visibilidad en IA.',
    seeAlso: [
      { label: 'Atribución', anchor: '#atribucion' },
      { label: 'ROI AEO', anchor: '#roi-aeo' },
      { label: 'Share-of-Voice', anchor: '#share-of-voice' },
      { label: 'Artículo · el tráfico de IA convierte mejor', href: '/blog/trafico-ia-convierte-42-mejor' },
    ],
  },
  {
    letter: 'T',
    term: 'Trigger',
    acro: 'TRIGGER · PROCESO',
    def: 'Condición explícita que dispara la siguiente acción cuando la actual alcanza umbral. Ejemplo: "cuando la dimensión Identidad del diagnóstico supera 18 de 25 puntos, activar el bloque de Reputación". Sin triggers no hay roadmap — solo hay lista de tareas.',
  },
  {
    letter: 'T',
    term: 'Trustpilot',
    acro: 'PLATAFORMA DE RESEÑAS · FUENTE',
    def: 'Plataforma de reseñas verificadas que los LLMs consumen como señal de reputación, porque verifica al reseñador. Reclamar el perfil, responder reseñas y sostener un volumen saludable es un quick win frecuente en nuestros casos: mueve la dimensión de reputación del diagnóstico y le da al modelo evidencia citable de que tu marca es confiable.',
  },

  /* U */
  {
    letter: 'U',
    term: 'UCP',
    acro: 'UNIVERSAL COMMERCE PROTOCOL · UCP / COMMERCE',
    def: 'El **Universal Commerce Protocol** es el estándar abierto de Google para el comercio agéntico, presentado en enero de 2026 y co-desarrollado con Shopify, Etsy, Wayfair y Target. Estandariza las primitivas de una transacción —**descubrimiento de producto, carrito, checkout y gestión de pedidos**— para que un agente pueda comprar contra tu tienda sin integraciones a medida por cada plataforma. Se apoya en AP2 para el pago y en A2A y MCP para la capa de agentes. Convive con ACP (OpenAI + Stripe): mismo problema, dos estándares, y quienes mueven el dinero —Stripe, Shopify— soportan ambos. El AEO te hace citable; UCP te hace comprable.',
    seeAlso: [
      { label: 'ACP', anchor: '#acp' },
      { label: 'AP2', anchor: '#ap2' },
      { label: 'Stack técnico', href: '/tecnologia' },
      {
        label: 'Google UCP',
        href: 'https://developers.google.com/merchant/ucp',
      },
      { label: 'Artículo · ACP y UCP', href: '/blog/comercio-agentico-acp-ucp' },
    ],
  },
  {
    letter: 'U',
    term: 'UX',
    acro: 'USER EXPERIENCE · MARCO',
    def: 'La calidad de la experiencia de un usuario al interactuar con un producto o sitio: navegación, velocidad, claridad, accesibilidad. En AEO el concepto se bifurca: la UX para humanos sigue importando (retención, conversión), pero emerge el AX — la experiencia equivalente para agentes LLM. Un sitio puede tener UX 10 y AX 0 si su catálogo no es legible por máquina.',
    seeAlso: [
      { label: 'AX', anchor: '#ax' },
      { label: 'Core Web Vitals', anchor: '#core-web-vitals' },
    ],
  },
  {
    letter: 'U',
    term: 'USP',
    acro: 'UNIQUE SELLING PROPOSITION · MARKETING',
    def: 'La razón única por la que un cliente debería elegirte a ti y no a tu competidor. En AEO la USP no la declaras: la inferimos de qué prompts te citan en posición #1. Si tu USP real (lo que el LLM dice) no coincide con tu USP declarada (lo que dice tu home), tienes un problema de identidad antes que de mensaje.',
  },

  /* V */
  {
    letter: 'V',
    term: 'Vector Database',
    acro: 'VECTOR DB · TÉCNICO',
    def: 'Base de datos optimizada para almacenar y buscar embeddings. Pinecone, Weaviate, Qdrant, pgvector son las más comunes. Cada motor generativo público corre uno o varios bajo el capó — y cada actualización del corpus pasa primero por ahí. Por eso AEO es un juego de velocidad: cuanto antes entra tu contenido al vector DB del motor, antes te cita.',
  },
  {
    letter: 'V',
    term: 'Voice search',
    acro: 'BÚSQUEDA POR VOZ · SEO / AEO',
    def: 'Consultas habladas a asistentes (Alexa, Google Assistant, Siri). Antes del AEO eran una categoría aparte; hoy convergen: la voz es solo otro front-end del mismo LLM. El asistente lee la primera respuesta — si no eres top-1 para una consulta de voz, simplemente no existes.',
  },
  {
    letter: 'V',
    term: 'Volumen de búsqueda',
    acro: 'SEARCH VOLUME · SEO',
    def: 'Búsquedas promedio mensuales para una keyword (Ahrefs, SEMrush, Google Keyword Planner). En AEO la métrica está rota: muchas consultas largas ya no pasan por SERP — pasan directo a ChatGPT y nunca aparecen en Keyword Planner. Recomendamos cruzar volumen de Google + logs de tu chatbot interno + entrevistas con clientes para estimar el volumen real de tu categoría.',
  },

  /* W */
  {
    letter: 'W',
    term: 'Wikidata',
    acro: 'WIKIDATA · FUENTE',
    def: 'Base de datos estructurada y abierta de entidades que alimenta el Knowledge Graph de Google y los corpus de la mayoría de los LLMs. Crear y mantener el ítem de tu marca — con referencias verificables, no autopromoción — es de las acciones más baratas con efecto en cadena: Wikidata → Knowledge Graph → Knowledge Panel → retrieval. Prerequisito práctico de toda disambiguación seria.',
    seeAlso: [
      { label: 'Knowledge Graph', anchor: '#knowledge-graph' },
      { label: 'sameAs', anchor: '#sameas' },
      { label: 'Disambiguación', anchor: '#disambiguacion' },
    ],
  },
  {
    letter: 'W',
    term: 'Wikipedia',
    acro: 'WIKIPEDIA · FUENTE',
    def: 'El dominio dominante en las citas de ChatGPT — los estudios de 2026 le atribuyen entre un cuarto y la mitad del share de citas top-10 — y fuente doble: retrieval en vivo más material de entrenamiento. También es la fuente prioritaria de los LLMs para validar entidades: una entrada en Wikipedia ES con fuentes Tier-1 desbloquea citas en Gemini y Google AIO en cuestión de días. Trátala como infraestructura, no como táctica: la entrada se gana con notabilidad real (cobertura de prensa independiente), requiere un editor con más de 100 ediciones previas y se mantiene con neutralidad.',
    seeAlso: [
      { label: 'Corpus de entrenamiento', anchor: '#corpus-de-entrenamiento' },
      { label: 'Artículo · las fuentes que la IA cita', href: '/blog/fuentes-que-la-ia-cita' },
    ],
  },
  {
    letter: 'W',
    term: 'Workspace',
    acro: 'ENTORNO · TÉCNICO',
    def: 'El entorno aislado donde un cliente gestiona su marca, catálogo de prompts, competidores monitoreados, historial de scores y reportes. Cada workspace ejecuta sus propios ciclos de medición y mantiene series de tiempo independientes. Un mismo cliente puede tener múltiples workspaces cuando opera varias marcas o mercados.',
    seeAlso: [{ label: 'Plataforma', href: '/' }],
  },

  {
    letter: 'X',
    term: 'xAI',
    acro: 'xAI · MOTOR',
    def: 'La empresa de IA fundada por Elon Musk, creadora de Grok y dueña de X (Twitter). La integración vertical importa: el motor y la red social comparten dueño, así que la conversación en X fluye hacia Grok sin intermediarios. Una de las pocas estructuras donde publicar en una red social es, literalmente, alimentar un motor generativo.',
    seeAlso: [{ label: 'Grok', anchor: '#grok' }],
  },

  /* Y */
  {
    letter: 'Y',
    term: 'YMYL',
    acro: 'YOUR MONEY YOUR LIFE · SEO',
    def: 'Categorías donde Google (y, por extensión, los LLMs) aplican el listón más alto de E-E-A-T: salud, finanzas, legal, seguridad. Si tu marca opera en YMYL, ningún truco táctico compensa la falta de autores firmados con credenciales verificables y políticas editoriales públicas. Cuesta más, pero el upside también: la barrera deja fuera a tu competencia que no quiso pagarla.',
  },

  {
    letter: 'Y',
    term: 'YouTube',
    acro: 'YOUTUBE · FUENTE',
    def: 'Top-3 de dominios citados en casi todos los estudios: los transcripts convierten cada video en un documento de texto indexable. Un tutorial de 10 minutos bien titulado, con descripción rica y capítulos, es contenido AEO de primera — y suele tener menos competencia por la cita que un blog post sobre el mismo tema. Para LatAm, además, es donde tu categoría ya se busca en español.',
    seeAlso: [
      { label: 'Multimodal', anchor: '#multimodal' },
      { label: 'Citabilidad', anchor: '#citabilidad' },
      { label: 'Artículo · las fuentes que la IA cita', href: '/blog/fuentes-que-la-ia-cita' },
    ],
  },

  /* Z */
  {
    letter: 'Z',
    term: 'Zero-click',
    acro: 'ZERO-CLICK · MARCO',
    def: 'Patrón en que el usuario obtiene su respuesta sin hacer clic en ningún resultado. Pew Research Center (julio 2025) midió que, cuando Google muestra un resumen de IA, los usuarios hacen clic en un resultado en el 8% de las visitas, frente al 15% sin resumen. Si la respuesta es zero-click, lo único que queda es ser citado en esa respuesta.',
    seeAlso: [
      { label: 'Artículo · AI Mode, 1.000 millones', href: '/blog/ai-mode-1000-millones-usuarios' },
    ],
  },
];

// Conteo único de términos. Lo consumen las superficies que antes hardcodeaban "166"
// (metadata del glosario, GlosarioHero, schema.js y las plantillas llms.txt/llms-full.txt).
export const TERM_COUNT = TERMS.length;

// Compilado para el MCP público (public/glosario.json). Texto plano, sin marcadores.
// Exportado: también lo usa schema.js para que el DefinedTermSet no lleve markdown.
export const stripMd = (t) => t.replace(/[`*]/g, '');
export const ALL_TERMS = TERMS.map((t) => ({
  term: t.term,
  acro: t.acro,
  def: stripMd(t.def),
}));

// Slug del ancla de cada término. Fuente única del slug: lo usa GlosarioIndex
// para el `id` de cada entrada Y glossaryHref para enlazar desde otras
// superficies (tips, artículos…) → los enlaces nunca driftean.
export function slugify(str) {
  return str
    .toLowerCase()
    .replace(/[áàä]/g, 'a')
    .replace(/[éèë]/g, 'e')
    .replace(/[íìï]/g, 'i')
    .replace(/[óòö]/g, 'o')
    .replace(/[úùü]/g, 'u')
    .replace(/[ñ]/g, 'n')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

const TERM_SLUGS = new Set(TERMS.map((t) => slugify(t.term)));

// Ancla canónica a un término del glosario. Lanza si el término no existe →
// evita enlaces a anclas inexistentes (se detecta en build).
export function glossaryHref(term) {
  const slug = slugify(term);
  if (!TERM_SLUGS.has(slug)) {
    throw new Error(`glossaryHref: término inexistente en el glosario: "${term}"`);
  }
  return `/glosario#${slug}`;
}
